var _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "background-simple",
    "data-motion": "blob",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.55,190.91c-.73-6.86-6.76-13.08-13.65-13-4.12.06-8.26,2.17-12.23,1.05s-6.45-5.22-7.88-9.16a30.14,30.14,0,0,0-6.1-10.53c-1.41-1.52-3.94-2.5-6.62-2.9h0a14,14,0,0,0-8,.83c-7.66,2.44-10.68,9.6-11.78,17.06-1.43,9.65,3.18,19.46,10.11,26.32A44,44,0,0,0,259,213.12c6.88.51,14.07-.73,19.75-4.62S288.28,197.76,287.55,190.91Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.62,200.66c-1.21,8.83,4.43,18.51,13.11,20.54,5.2,1.21,11-.16,15.68,2.48s6.48,8.55,7,13.93a38.85,38.85,0,0,0,4.4,15.12c1.3,2.35,4.17,4.36,7.4,5.7h0c3.53,1.46,7.46,2.09,10.24,1.42,10.38-.69,16.39-8.74,20.09-17.76,4.79-11.68,2.05-25.42-4.53-36.19a57,57,0,0,0-30.68-24.27c-8.48-2.77-17.89-3.45-26.23-.32S396.82,191.83,395.62,200.66Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.45,151.38c12,1.65,25.28-6,28-17.9,1.65-7.1-.21-15.08,3.39-21.41s11.67-8.86,19-9.63,14.17-2.43,20.63-6c3.21-1.77,6-5.7,7.79-10.11v0a.14.14,0,0,0,0-.07c2-4.81,2.85-10.18,1.94-14-.94-14.17-11.93-22.37-24.26-27.42-15.93-6.54-34.7-2.8-49.41,6.18A77.91,77.91,0,0,0,22.47,93c-3.77,11.57-4.7,24.41-.43,35.81S36.39,149.73,48.45,151.38Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.21,
    cy: 177.92,
    r: 10.5,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.7,
    cy: 94.72,
    r: 10.5,
    transform: "translate(27.87 224.62) rotate(-76.78)",
    style: {
      fill: "#F0F5FA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.24,479.76c0,.15-103.09.27-230.23.27s-230.25-.12-230.25-.27,103.07-.26,230.25-.26S479.24,479.62,479.24,479.76Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "furniture"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.78,
    y: 37.32,
    width: 76.83,
    height: 99.34,
    transform: "translate(604.4 173.98) rotate(180)",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.62,
    y: 44.09,
    width: 64.07,
    height: 84.83,
    transform: "translate(605.3 173.01) rotate(180)",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.01,
    y: 70.94,
    width: 2.62,
    height: 33.57,
    transform: "translate(534.64 175.44) rotate(180)",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,127.47c-.15,0-.26-18.64-.26-41.62s.11-41.62.26-41.62.26,18.63.26,41.62S309.13,127.47,309,127.47Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.29,
    y: 86.99,
    width: 64.39,
    height: 6.65,
    transform: "translate(604.98 180.63) rotate(180)",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.19,94.14h-65.4V86.49h65.4Zm-64.4-1h63.4V87.49h-63.4Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.62,44.09l1.14,0,3.37,0L288.05,44l46.63-.11h.22v.21c0,24,0,53.26.05,84.82h0v.26h-.27l-64.06,0h-.24v-.23c.05-25.17.09-46.4.12-61.35,0-7.44.05-13.31.06-17.35,0-2,0-3.52,0-4.57,0-.51,0-.89,0-1.17s0-.39,0-.39,0,.15,0,.42,0,.68,0,1.19q0,1.61,0,4.62c0,4,0,9.94.07,17.4,0,14.92.06,36.09.11,61.2l-.23-.24,64.06,0-.26.26h0c0-31.56,0-60.84.05-84.82l.21.22-46.5-.11-13-.06-3.42,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.77,44.22a18.38,18.38,0,0,1,2.72-3.55,19.06,19.06,0,0,1,3.11-3.2A19.4,19.4,0,0,1,337.88,41,20.38,20.38,0,0,1,334.77,44.22Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.78,37.32a18.25,18.25,0,0,1,4,2.92A12.91,12.91,0,0,1,270.92,44c-.12.1-1.52-1.58-3.53-3.36A32.91,32.91,0,0,1,263.78,37.32Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.52,129.57a21.11,21.11,0,0,1,2.94,3.61,20.94,20.94,0,0,1,2.52,3.91,20.58,20.58,0,0,1-2.94-3.61A20.94,20.94,0,0,1,335.52,129.57Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.65,137.12a33.65,33.65,0,0,1,7.61-8.12,49.2,49.2,0,0,1-3.76,4.1A49.21,49.21,0,0,1,263.65,137.12Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.84,86.65h-11a2.3,2.3,0,0,1-2.29-2.29V65.48h17.32l-1.75,1.74V84.36A2.29,2.29,0,0,1,312.84,86.65Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.84,86.65a2.8,2.8,0,0,0,1.36-.54,2.31,2.31,0,0,0,.81-1.49c0-.68,0-1.51,0-2.42,0-3.7-.05-8.87-.09-15v-.1l.07-.07,1.74-1.74.17.41-13.79,0h-3.53l.26-.26c0,4.7,0,9.13,0,13.16,0,2,0,3.91,0,5.69a2.09,2.09,0,0,0,1.15,1.9,2.14,2.14,0,0,0,1.09.23h1.15l7.1.08,1.92,0a2.64,2.64,0,0,1,.66.05,5,5,0,0,1-.66,0l-1.92,0-7.1.08H302a2.59,2.59,0,0,1-1.26-.25,2.5,2.5,0,0,1-1.4-2.25c0-1.78,0-3.68,0-5.69,0-4,0-8.46,0-13.16v-.26h3.79l13.79,0h.59l-.42.41-1.75,1.73.06-.16c0,6.11-.07,11.28-.09,15,0,.92,0,1.71,0,2.45a2.39,2.39,0,0,1-.93,1.57,2.13,2.13,0,0,1-1.06.43A1.31,1.31,0,0,1,312.84,86.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,70.82a22.71,22.71,0,0,1-4,0,20.45,20.45,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,68.57a2.2,2.2,0,0,1-.9.1,2.17,2.17,0,0,1-.89-.1,2.17,2.17,0,0,1,.89-.1A2.2,2.2,0,0,1,301.5,68.57Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,75.28a20.45,20.45,0,0,1-4,0,20.45,20.45,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,73a2,2,0,0,1-.9.1,2,2,0,0,1-.89-.1,2.17,2.17,0,0,1,.89-.1A2.2,2.2,0,0,1,301.5,73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,79.74a20.45,20.45,0,0,1-4,0,20.45,20.45,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,77.49a2,2,0,0,1-.9.1,2,2,0,0,1-.89-.1,2.28,2.28,0,0,1,.89-.09A2.31,2.31,0,0,1,301.5,77.49Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,84.2a20.45,20.45,0,0,1-4,0,20.45,20.45,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,82a2,2,0,0,1-.9.1,2,2,0,0,1-.89-.1,2.28,2.28,0,0,1,.89-.09A2.31,2.31,0,0,1,301.5,82Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.57,113.2c0,4.13,0,10.8,0,13.87a1.63,1.63,0,0,0,1.63,1.63l11.28,0a1.64,1.64,0,0,0,1.65-1.63l0-13.75a3.63,3.63,0,0,0-3.63-3.64h0v-2l-7.39,0v1.91h0A3.64,3.64,0,0,0,292.57,113.2Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.57,113.2a3.39,3.39,0,0,1,0-.37,3.63,3.63,0,0,1,1.32-2.5,3.77,3.77,0,0,1,2.24-.84l-.08.09c0-.59,0-1.23,0-1.91v-.1h.1l7.39,0h.13v2.16l-.14-.14a3.8,3.8,0,0,1,1.82.47,3.81,3.81,0,0,1,2,3.31v2c0,2.75,0,5.65,0,8.65v2.56a4.46,4.46,0,0,1,0,.88,1.81,1.81,0,0,1-1.16,1.31,2.41,2.41,0,0,1-.87.1h-.81l-6.26,0-2.92,0h-.7a3,3,0,0,1-.72-.05,1.77,1.77,0,0,1-1.13-.86,1.82,1.82,0,0,1-.22-.67c0-.25,0-.45,0-.66,0-.43,0-.85,0-1.26,0-.83,0-1.62,0-2.37,0-3,.05-5.44.06-7.15,0-.82,0-1.47,0-1.94,0-.21,0-.37,0-.5a1.23,1.23,0,0,1,0-.18s0,.06,0,.18,0,.29,0,.5l0,1.94c0,1.71,0,4.15.05,7.15v2.37c0,.41,0,.83,0,1.26,0,.2,0,.44,0,.63a1.46,1.46,0,0,0,.18.57,1.53,1.53,0,0,0,1,.73,3.44,3.44,0,0,0,.66,0H305.2a1.93,1.93,0,0,0,.77-.08,1.47,1.47,0,0,0,.95-1.08,4.19,4.19,0,0,0,0-.81V124c0-3,0-5.9,0-8.66,0-.68,0-1.36,0-2a3.52,3.52,0,0,0-3.48-3.51h-.14v-2.15l.14.13-7.39,0,.1-.1c0,.68,0,1.32,0,1.91v.08h-.08a3.61,3.61,0,0,0-3.22,2.12A4.67,4.67,0,0,0,292.57,113.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.22 107.92 296.22 108.84 303.36 109.12 303.36 107.94 296.22 107.92",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.95,104.86h5.8a1.65,1.65,0,0,1,1.65,1.65v1.42a.59.59,0,0,1-.59.59h-7.93a.59.59,0,0,1-.59-.59v-1.42A1.65,1.65,0,0,1,296.95,104.86Z",
    transform: "translate(0.26 -0.72) rotate(0.14)",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.46,108.53a8.06,8.06,0,0,1-.1-1.82,9.81,9.81,0,0,1,.1-1.83,8.12,8.12,0,0,1,.1,1.83A9.74,9.74,0,0,1,296.46,108.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.43,108.53a8.38,8.38,0,0,1-.09-1.82,8.12,8.12,0,0,1,.1-1.83,9.36,9.36,0,0,1,.09,1.83A8.74,8.74,0,0,1,297.43,108.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,108.54a9.36,9.36,0,0,1-.09-1.83,8.88,8.88,0,0,1,.1-1.83,8.51,8.51,0,0,1,.09,1.83A8.12,8.12,0,0,1,298.4,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.38,108.54a8.12,8.12,0,0,1-.1-1.83,9.65,9.65,0,0,1,.1-1.82,8,8,0,0,1,.1,1.82A9.81,9.81,0,0,1,299.38,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.35,108.54a8.51,8.51,0,0,1-.09-1.83,8.06,8.06,0,0,1,.1-1.82,9.36,9.36,0,0,1,.09,1.83A8.82,8.82,0,0,1,300.35,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.32,108.54a9.3,9.3,0,0,1-.09-1.82,8.88,8.88,0,0,1,.1-1.83,7.81,7.81,0,0,1,.09,1.83A8,8,0,0,1,301.32,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,108.54a8,8,0,0,1-.1-1.82,8.45,8.45,0,0,1,.11-1.83,9.36,9.36,0,0,1,.09,1.83A8.74,8.74,0,0,1,302.3,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,108.55a8.51,8.51,0,0,1-.09-1.83,8.74,8.74,0,0,1,.1-1.82,9.21,9.21,0,0,1,.09,1.82A8.88,8.88,0,0,1,303.27,108.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.62,
    y: 115.21,
    width: 10.58,
    height: 7,
    rx: 1.48,
    transform: "matrix(1, 0, 0, 1, 0.29, -0.72)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.49,121.74a.87.87,0,0,0,0-.11v-.33c0-.3,0-.71,0-1.23,0-1.07,0-2.57,0-4.4l.08.07h-9.28l.1-.1h0v3.12c0,1,0,2,0,2.93l-.09-.09,6.66.06,1.92,0h.7s-.05,0-.16,0h-.5l-1.9,0-6.72,0h-.08v-6.16h0c-.08.09.12-.12.1-.09l9.28,0h.07v.08c0,1.85,0,3.37-.05,4.45,0,.51,0,.91,0,1.21v.31A.28.28,0,0,1,304.49,121.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.07,117.63a27.81,27.81,0,0,1-3.16.09,24.83,24.83,0,0,1-3.15-.11,49.83,49.83,0,0,1,6.31,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.06,118.7a27.56,27.56,0,0,1-3.15.09,26.12,26.12,0,0,1-3.15-.1,23,23,0,0,1,3.15-.09A26.12,26.12,0,0,1,303.06,118.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.06,119.73a27.56,27.56,0,0,1-3.15.09,26.12,26.12,0,0,1-3.15-.1,23,23,0,0,1,3.15-.09A26.12,26.12,0,0,1,303.06,119.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.1,109.64a27.37,27.37,0,0,1-3.44.09,31.14,31.14,0,0,1-3.44-.1,27.37,27.37,0,0,1,3.44-.09A31.14,31.14,0,0,1,303.1,109.64Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,126.27a5.59,5.59,0,0,1,0-.65c0-.45,0-1.05,0-1.77,0-1.5,0-3.57,0-5.85,0-1.14,0-2.23,0-3.22a6.46,6.46,0,0,1,.44-2.61,2.86,2.86,0,0,1,1.17-1.33,1.87,1.87,0,0,1,.45-.18.72.72,0,0,1,.17,0,5.2,5.2,0,0,0-.58.27,2.87,2.87,0,0,0-1.09,1.33,6.47,6.47,0,0,0-.38,2.55c0,1,0,2.08,0,3.22,0,2.28,0,4.35-.06,5.85,0,.72,0,1.32,0,1.77A4.21,4.21,0,0,1,293.17,126.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,128.21l-.51-.16-.58-.2c-.23-.07-.49-.16-.79-.23a16.25,16.25,0,0,0-2.08-.44,20.66,20.66,0,0,0-2.6-.2,19,19,0,0,0-2.6.19,18.33,18.33,0,0,0-2.08.43c-.3.07-.56.16-.79.23a5.93,5.93,0,0,0-.59.19,3.44,3.44,0,0,1-.51.16A2.88,2.88,0,0,1,294,128c.16-.07.35-.15.58-.23s.49-.17.79-.25a15.58,15.58,0,0,1,2.09-.48,17,17,0,0,1,5.26,0,15.84,15.84,0,0,1,2.09.49c.29.08.55.18.78.26s.43.16.58.23A2.09,2.09,0,0,1,306.6,128.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14,113.2c0,4.13,0,10.8,0,13.87a1.63,1.63,0,0,0,1.64,1.63l11.28,0a1.64,1.64,0,0,0,1.64-1.63l0-13.75a3.63,3.63,0,0,0-3.63-3.64h0v-2l-7.39,0v1.91h0A3.63,3.63,0,0,0,281.14,113.2Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14,113.2a2,2,0,0,1,0-.37,4,4,0,0,1,.26-1.07,3.68,3.68,0,0,1,1.06-1.43,3.8,3.8,0,0,1,2.25-.84l-.09.09c0-.59,0-1.23,0-1.91v-.1h.1l7.39,0h.13v2.16l-.13-.14a3.85,3.85,0,0,1,1.82.47,3.9,3.9,0,0,1,1.41,1.36,3.86,3.86,0,0,1,.54,1.95v2c0,2.75,0,5.65,0,8.65,0,.57,0,1.15,0,1.71v.85a5.33,5.33,0,0,1,0,.88,1.82,1.82,0,0,1-1.17,1.31,2.35,2.35,0,0,1-.86.1H293l-6.26,0-2.91,0h-.71a3,3,0,0,1-.72-.05,1.8,1.8,0,0,1-1.13-.86,1.82,1.82,0,0,1-.22-.67c0-.25,0-.45,0-.66v-1.26c0-.83,0-1.62,0-2.37,0-3,0-5.44.05-7.15,0-.82,0-1.47,0-1.94l0-.5c0-.12,0-.18,0-.18a1.23,1.23,0,0,1,0,.18l0,.5c0,.47,0,1.12,0,1.94,0,1.71,0,4.15,0,7.15,0,.75,0,1.54,0,2.37v1.26c0,.2,0,.44,0,.63a1.48,1.48,0,0,0,.19.57,1.51,1.51,0,0,0,1,.73,3.5,3.5,0,0,0,.66,0h10.7a1.9,1.9,0,0,0,.76-.08,1.5,1.5,0,0,0,1-1.08,4.23,4.23,0,0,0,0-.81V124c0-3,0-5.9,0-8.66v-2a3.5,3.5,0,0,0-.49-1.8,3.54,3.54,0,0,0-3-1.71H292v-2.15l.13.13-7.39,0,.1-.1c0,.68,0,1.32,0,1.91v.08h-.09a3.56,3.56,0,0,0-2.16.77,3.69,3.69,0,0,0-1.06,1.35A4.42,4.42,0,0,0,281.14,113.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.78 107.92 284.78 108.84 291.92 109.12 291.93 107.94 284.78 107.92",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.51,104.86h5.8a1.65,1.65,0,0,1,1.65,1.65v1.42a.59.59,0,0,1-.59.59h-7.93a.59.59,0,0,1-.59-.59v-1.42a1.65,1.65,0,0,1,1.65-1.65Z",
    transform: "translate(0.26 -0.69) rotate(0.14)",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,108.53a8.45,8.45,0,0,1-.09-1.82,8.12,8.12,0,0,1,.1-1.83,9.36,9.36,0,0,1,.09,1.83A8.82,8.82,0,0,1,285,108.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,108.53a9.21,9.21,0,0,1-.09-1.82,8.88,8.88,0,0,1,.1-1.83,8.51,8.51,0,0,1,.09,1.83A8,8,0,0,1,286,108.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,108.54a8.12,8.12,0,0,1-.1-1.83,9.81,9.81,0,0,1,.1-1.83,8.12,8.12,0,0,1,.1,1.83A9.81,9.81,0,0,1,287,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.94,108.54a8.51,8.51,0,0,1-.09-1.83,8,8,0,0,1,.1-1.82,9.21,9.21,0,0,1,.09,1.82A8.88,8.88,0,0,1,287.94,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,108.54a9.36,9.36,0,0,1-.09-1.83,8.82,8.82,0,0,1,.1-1.82,7.81,7.81,0,0,1,.09,1.83A8.06,8.06,0,0,1,288.91,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.89,108.54a8.06,8.06,0,0,1-.1-1.82,8.45,8.45,0,0,1,.11-1.83,9.36,9.36,0,0,1,.09,1.83A8.74,8.74,0,0,1,289.89,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,108.54a8.38,8.38,0,0,1-.09-1.82,8.88,8.88,0,0,1,.1-1.83,9.36,9.36,0,0,1,.09,1.83A8.74,8.74,0,0,1,290.86,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,108.55a9.36,9.36,0,0,1-.09-1.83,8.74,8.74,0,0,1,.1-1.82,7.69,7.69,0,0,1,.09,1.82A8.12,8.12,0,0,1,291.83,108.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.19,
    y: 115.21,
    width: 10.58,
    height: 7,
    rx: 1.48,
    transform: "translate(0.29 -0.7) rotate(0.14)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.06,121.74s0,0,0-.11,0-.2,0-.33c0-.3,0-.71,0-1.23,0-1.07,0-2.57,0-4.4l.08.07h-9.28s.19-.18.1-.1h0v1.57c0,.53,0,1.05,0,1.55,0,1,0,2,0,2.93l-.09-.09,6.66.06,1.91,0h.71s-.06,0-.17,0h-.5l-1.9,0-6.71,0h-.09v-6.16h0c-.09.09.11-.12.09-.09l9.28,0h.08v.08c0,1.85,0,3.37,0,4.45,0,.51,0,.91,0,1.21v.41Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.63,117.63a27.56,27.56,0,0,1-3.15.09,24.83,24.83,0,0,1-3.15-.11,49.66,49.66,0,0,1,6.3,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.63,118.7a27.67,27.67,0,0,1-3.16.09,26.12,26.12,0,0,1-3.15-.1,23.06,23.06,0,0,1,3.16-.09A26.12,26.12,0,0,1,291.63,118.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.62,119.73a27.56,27.56,0,0,1-3.15.09,26.12,26.12,0,0,1-3.15-.1,23,23,0,0,1,3.15-.09A26.12,26.12,0,0,1,291.62,119.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.66,109.64a27.37,27.37,0,0,1-3.44.09,31.14,31.14,0,0,1-3.44-.1,27.37,27.37,0,0,1,3.44-.09A31.14,31.14,0,0,1,291.66,109.64Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.73,126.27a5.59,5.59,0,0,1,0-.65c0-.45,0-1.05,0-1.77,0-1.5,0-3.57,0-5.85,0-1.14,0-2.23,0-3.22a6.3,6.3,0,0,1,.43-2.61,2.86,2.86,0,0,1,1.17-1.33,1.76,1.76,0,0,1,.46-.18.65.65,0,0,1,.17,0,4.77,4.77,0,0,0-.59.27,2.93,2.93,0,0,0-1.09,1.33,6.48,6.48,0,0,0-.37,2.55c0,1,0,2.08,0,3.22,0,2.28,0,4.35-.06,5.85,0,.72,0,1.32,0,1.77A3.39,3.39,0,0,1,281.73,126.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.16,128.21l-.5-.16-.59-.2c-.23-.07-.49-.16-.78-.23a16.82,16.82,0,0,0-2.09-.44,20.51,20.51,0,0,0-2.6-.2,19.13,19.13,0,0,0-2.6.19,18.33,18.33,0,0,0-2.08.43c-.3.07-.56.16-.79.23a5.93,5.93,0,0,0-.59.19l-.5.16a2.09,2.09,0,0,1,.48-.23c.15-.07.35-.15.58-.23s.49-.17.78-.25A16.14,16.14,0,0,1,286,127a16.91,16.91,0,0,1,5.25,0,15.47,15.47,0,0,1,2.09.49c.3.08.56.18.79.26s.42.16.58.23A2.13,2.13,0,0,1,295.16,128.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.92,
    y: 37.32,
    width: 76.83,
    height: 99.34,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.85,
    y: 44.09,
    width: 64.07,
    height: 84.83,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.58,
    y: 37.32,
    width: 15.01,
    height: 100,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 70.94,
    width: 2.62,
    height: 33.57,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.55,128.79c-.14,0-.26-18.93-.26-42.28s.12-42.28.26-42.28.26,18.93.26,42.28S218.69,128.79,218.55,128.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.85,
    y: 86.99,
    width: 64.39,
    height: 6.65,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,94.14H192.35V86.49h65.39Zm-64.39-1h63.39V87.49H193.35Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.73,66.17l.2,17.65a1.83,1.83,0,0,0,1.83,1.77h0a1.84,1.84,0,0,0,1.85-1.89V66.21Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.73,66.17h3.92v0c0,2,0,4.72,0,7.88v7.79c0,.47,0,.94,0,1.41,0,.23,0,.47,0,.72a2,2,0,0,1-.25.71,1.9,1.9,0,0,1-.88.78,1.85,1.85,0,0,1-1.16.13,1.93,1.93,0,0,1-1.5-1.57,3.57,3.57,0,0,1,0-.56c0-.18,0-.36,0-.54,0-.36,0-.71,0-1.06,0-.71,0-1.4,0-2.07,0-2.68,0-5.1-.05-7.13s0-3.65,0-4.79c0-.56,0-1,0-1.3v-.44a.55.55,0,0,1,0,.12v.34c0,.31,0,.75,0,1.32,0,1.14,0,2.78.08,4.8s.07,4.43.1,7.1c0,.67,0,1.36,0,2.05,0,.35,0,.71,0,1.06,0,.18,0,.36,0,.54a3.08,3.08,0,0,0,0,.53,1.77,1.77,0,0,0,1.38,1.45,1.79,1.79,0,0,0,1.07-.12,1.82,1.82,0,0,0,.81-.72,1.85,1.85,0,0,0,.22-.65,5.35,5.35,0,0,0,0-.7V79.15c0-1.78,0-3.48,0-5.06,0-3.16,0-5.86,0-7.88l.05,0-2.85,0-.76,0h-.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,75.22l0,8.4a1.55,1.55,0,0,0,1.55,1.5h0a1.55,1.55,0,0,0,1.56-1.6l-.06-8.27Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.59,
    y: 64.91,
    width: 6.16,
    height: 3.79,
    rx: 0.84,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,12.18,12.18,0,0,1,.07,1.86A12.26,12.26,0,0,1,239,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.89,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,239.89,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.76,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,240.76,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.63,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,241.63,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,12.18,12.18,0,0,1,.07,1.86A12.26,12.26,0,0,1,242.5,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,243.36,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.23,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,244.23,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.77,
    y: 71.04,
    width: 2.05,
    height: 9.13,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,66.17l.2,17.65a1.84,1.84,0,0,0,1.84,1.77h0a1.84,1.84,0,0,0,1.84-1.89V66.21Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,66.17h3.92v0c0,2,0,4.72,0,7.88v5.06c0,.89,0,1.8,0,2.73v1.41c0,.23,0,.47,0,.72a2,2,0,0,1-.25.71,1.94,1.94,0,0,1-2,.91,1.93,1.93,0,0,1-1.5-1.57,3.57,3.57,0,0,1,0-.56c0-.18,0-.36,0-.54,0-.36,0-.71,0-1.06,0-.71,0-1.4,0-2.07,0-2.68,0-5.1-.05-7.13s0-3.65,0-4.79V66.17s0,0,0,.12v.34c0,.31,0,.75,0,1.32,0,1.14,0,2.78.07,4.8s.07,4.43.11,7.1c0,.67,0,1.36,0,2.05,0,.35,0,.71,0,1.06v.54a3.08,3.08,0,0,0,0,.53,1.76,1.76,0,0,0,3.26.61,1.67,1.67,0,0,0,.22-.65,5.35,5.35,0,0,0,0-.7V79.15c0-1.78,0-3.48,0-5.06,0-3.16,0-5.86,0-7.88l0,0-2.84,0-.77,0h-.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.07,75.22l0,8.4a1.55,1.55,0,0,0,1.55,1.5h0a1.55,1.55,0,0,0,1.56-1.6l-.06-8.27Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.43,
    y: 64.91,
    width: 6.16,
    height: 3.79,
    rx: 1,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.87,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,230.87,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,12.18,12.18,0,0,1,.07,1.86A12.26,12.26,0,0,1,231.74,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,232.6,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.47,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,233.47,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.34,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,12.18,12.18,0,0,1,.07,1.86A12.26,12.26,0,0,1,234.34,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,235.2,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.07,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,236.07,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.61,
    y: 71.04,
    width: 2.05,
    height: 9.13,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,66.17l.2,17.65a1.84,1.84,0,0,0,1.84,1.77h0a1.83,1.83,0,0,0,1.84-1.89V66.21Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,66.17h3.92v0c0,2,0,4.72,0,7.88,0,1.58,0,3.28,0,5.06v4.14c0,.23,0,.47,0,.72a2.21,2.21,0,0,1-.24.71,2,2,0,0,1-.88.78,1.87,1.87,0,0,1-1.16.13,1.93,1.93,0,0,1-1.51-1.57,3.57,3.57,0,0,1,0-.56V83c0-.36,0-.71,0-1.06,0-.71,0-1.4,0-2.07,0-2.68,0-5.1-.06-7.13s0-3.65,0-4.79V66.17s0,0,0,.12v.34q0,.47,0,1.32c0,1.14,0,2.78.08,4.8s.06,4.43.1,7.1c0,.67,0,1.36,0,2.05,0,.35,0,.71,0,1.06v.54a4.58,4.58,0,0,0,0,.53,1.76,1.76,0,0,0,3.26.61,1.67,1.67,0,0,0,.22-.65,5.35,5.35,0,0,0,0-.7V79.15c0-1.78,0-3.48,0-5.06,0-3.16,0-5.86,0-7.88l0,0-2.84,0-.77,0h-.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,75.22l0,8.4a1.56,1.56,0,0,0,1.56,1.5h0a1.54,1.54,0,0,0,1.55-1.6l-.06-8.27Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 64.91,
    width: 6.16,
    height: 3.79,
    rx: 0.82,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.84,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,222.84,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,12.18,12.18,0,0,1,.07,1.86A12.26,12.26,0,0,1,223.71,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.57,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,224.57,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,225.44,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.31,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,226.31,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.17,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,227.17,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,228,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.59,
    y: 71.04,
    width: 2.05,
    height: 9.13,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.51,66.17l.2,17.65a1.84,1.84,0,0,0,1.84,1.77h0a1.83,1.83,0,0,0,1.84-1.89V66.21Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.51,66.17h3.92v0c0,2,0,4.72,0,7.88,0,1.58,0,3.28,0,5.06v4.14c0,.23,0,.47,0,.72a2,2,0,0,1-.24.71,1.9,1.9,0,0,1-.88.78,1.87,1.87,0,0,1-1.16.13,1.93,1.93,0,0,1-1.51-1.57,3.57,3.57,0,0,1,0-.56V83c0-.36,0-.71,0-1.06,0-.71,0-1.4,0-2.07,0-2.68,0-5.1-.06-7.13s0-3.65,0-4.79V66.17s0,0,0,.12v.34q0,.47,0,1.32c0,1.14,0,2.78.08,4.8s.06,4.43.1,7.1c0,.67,0,1.36,0,2.05,0,.35,0,.71,0,1.06v.54a4.58,4.58,0,0,0,0,.53,1.75,1.75,0,0,0,2.45,1.33,1.72,1.72,0,0,0,.81-.72,1.87,1.87,0,0,0,.23-.65c0-.22,0-.46,0-.7V81.88c0-.93,0-1.84,0-2.73V74.09c0-3.16,0-5.86,0-7.88l0,0-2.84,0-.77,0h-.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,75.22l0,8.4a1.56,1.56,0,0,0,1.56,1.5h0a1.54,1.54,0,0,0,1.55-1.6l-.06-8.27Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.37,
    y: 64.91,
    width: 6.16,
    height: 3.79,
    rx: 0.77,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.81,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,214.81,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.68,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,215.68,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.54,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,216.54,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.41,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,217.41,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.28,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,218.28,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.15,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,12.18,12.18,0,0,1,.07,1.86A12.26,12.26,0,0,1,219.15,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,220,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.56,
    y: 71.04,
    width: 2.05,
    height: 9.13,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.49,66.17l.19,17.65a1.84,1.84,0,0,0,1.84,1.77h0a1.83,1.83,0,0,0,1.84-1.89V66.21Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.49,66.17h3.92v0c0,2,0,4.72,0,7.88,0,1.58,0,3.28,0,5.06v4.14c0,.23,0,.47,0,.72a2,2,0,0,1-.24.71,1.9,1.9,0,0,1-.88.78,1.87,1.87,0,0,1-1.16.13,1.93,1.93,0,0,1-1.51-1.57,3.57,3.57,0,0,1,0-.56V83c0-.36,0-.71,0-1.06,0-.71,0-1.4,0-2.07,0-2.68,0-5.1-.06-7.13s0-3.65,0-4.79V66.28c0-.08,0-.11,0-.11v.12c0,.08,0,.2,0,.34q0,.47,0,1.32c0,1.14,0,2.78.08,4.8s.06,4.43.1,7.1c0,.67,0,1.36,0,2.05,0,.35,0,.71,0,1.06v.54a4.58,4.58,0,0,0,0,.53,1.75,1.75,0,0,0,2.45,1.33,1.72,1.72,0,0,0,.81-.72,1.87,1.87,0,0,0,.23-.65,5.4,5.4,0,0,0,0-.7V81.88c0-.93,0-1.84,0-2.73V74.09c0-3.16,0-5.86,0-7.88l0,0-2.84,0-.77,0h-.26Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,75.22l0,8.4a1.56,1.56,0,0,0,1.56,1.5h0a1.56,1.56,0,0,0,1.56-1.6l-.07-8.27Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.34,
    y: 64.91,
    width: 6.16,
    height: 3.79,
    rx: 0.57,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.78,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,206.78,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,207.65,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,208.51,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,209.38,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.25,68.64a11.47,11.47,0,0,1-.08-1.87,11.39,11.39,0,0,1,.08-1.86,11.39,11.39,0,0,1,.08,1.86A11.47,11.47,0,0,1,210.25,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.12,68.64a10.26,10.26,0,0,1-.08-1.87,10.19,10.19,0,0,1,.08-1.86,12.18,12.18,0,0,1,.07,1.86A12.26,12.26,0,0,1,211.12,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,68.64a12.26,12.26,0,0,1-.07-1.87,12.18,12.18,0,0,1,.07-1.86,10.19,10.19,0,0,1,.08,1.86A10.26,10.26,0,0,1,212,68.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.53,
    y: 71.04,
    width: 2.05,
    height: 9.13,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.57,
    y: 70.44,
    width: 45.32,
    height: 1.21,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.57,
    y: 85.48,
    width: 45.32,
    height: 1.21,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.2,
    y: 71.04,
    width: 1.36,
    height: 15.04,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.16,
    y: 71.04,
    width: 1.36,
    height: 15.04,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.47,86.51h-11a2.29,2.29,0,0,1-2.29-2.29V65.34h17.32l-1.75,1.74V84.22A2.28,2.28,0,0,1,287.47,86.51Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.47,86.51a2.68,2.68,0,0,0,1.36-.54,2.21,2.21,0,0,0,.8-1.48c0-.68,0-1.52,0-2.42,0-3.7-.06-8.87-.09-15V67l.07-.07,1.74-1.75.17.42H274.19l.26-.26c0,4.7,0,9.14,0,13.17,0,2,0,3.91,0,5.69a2.09,2.09,0,0,0,1.15,1.9,2.14,2.14,0,0,0,1.09.23h1.15l7.1.08,1.91,0a5,5,0,0,1,.67.05,2.69,2.69,0,0,1-.67,0l-1.91,0-7.1.08h-1.15a2.68,2.68,0,0,1-1.26-.25A2.51,2.51,0,0,1,274,84.2c0-1.78,0-3.69,0-5.69,0-4,0-8.47,0-13.17v-.25h3.79l13.79,0h.59l-.42.42-1.76,1.73.07-.17c0,6.12-.07,11.29-.09,15,0,.91,0,1.71,0,2.45a2.33,2.33,0,0,1-2,2A1.05,1.05,0,0,1,287.47,86.51Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,70.68a20.45,20.45,0,0,1-4,0,22.71,22.71,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.13,68.44a2.31,2.31,0,0,1-.9.09,2.28,2.28,0,0,1-.89-.09,2,2,0,0,1,.89-.1A2,2,0,0,1,276.13,68.44Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,75.15a22.71,22.71,0,0,1-4,0,20.45,20.45,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.13,72.9a2.2,2.2,0,0,1-.9.1,2.17,2.17,0,0,1-.89-.1,2,2,0,0,1,.89-.1A2,2,0,0,1,276.13,72.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,79.61a22.71,22.71,0,0,1-4,0,20.45,20.45,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.13,77.36a2.2,2.2,0,0,1-.9.1,2.17,2.17,0,0,1-.89-.1,2.17,2.17,0,0,1,.89-.1A2.2,2.2,0,0,1,276.13,77.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,84.07a20.45,20.45,0,0,1-4,0,20.45,20.45,0,0,1,4,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.13,81.82a2,2,0,0,1-.9.1,2,2,0,0,1-.89-.1,2.17,2.17,0,0,1,.89-.1A2.2,2.2,0,0,1,276.13,81.82Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,57.1h0a.59.59,0,0,0,.59.6h1.07V68.54l-6.54,14.51a2.48,2.48,0,0,0,2.26,3.5h13a2.47,2.47,0,0,0,2.26-3.5l-6.78-15V57.77h1a.63.63,0,0,0,.63-.63h0a.63.63,0,0,0-.63-.63h-6.22A.58.58,0,0,0,292,57.1Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,57.1s-.11-.32.33-.58a11.92,11.92,0,0,1,2-.1l3.17,0h1a2,2,0,0,1,.54,0,.77.77,0,0,1,.49.39.8.8,0,0,1-.45,1.11,8.29,8.29,0,0,1-1.2,0l.16-.16c0,2.89,0,6.39.05,10.3l0-.09c1.43,3.12,3,6.54,4.65,10.18.42.91.84,1.83,1.26,2.77.22.47.43.94.65,1.42a4.45,4.45,0,0,1,.51,1.58,2.75,2.75,0,0,1-1.84,2.73,2.62,2.62,0,0,1-.88.15H289.9a4.93,4.93,0,0,1-1.13-.08,2.78,2.78,0,0,1-1.77-1.4,2.71,2.71,0,0,1-.12-2.21c.27-.65.55-1.24.82-1.86l5.83-12.8,0,.08c.05-5,.09-8.7.11-10.84l.08.08-.89,0a.76.76,0,0,1-.61-.19c-.24-.28-.16-.48-.16-.47a.68.68,0,0,0,.21.41.71.71,0,0,0,.56.14l.89,0h.07v.07c0,2.14.06,5.86.11,10.84v0l0,0c-1.62,3.65-3.56,8-5.72,12.85-.26.6-.56,1.23-.81,1.83a2.24,2.24,0,0,0,.11,1.81,2.28,2.28,0,0,0,1.45,1.14,4.61,4.61,0,0,0,1,.06h12.53a2.16,2.16,0,0,0,.71-.12A2.23,2.23,0,0,0,304.63,84a3.73,3.73,0,0,0-.46-1.39c-.21-.48-.43-1-.64-1.42l-1.25-2.78c-1.65-3.64-3.19-7.07-4.59-10.2l0,0v-.05c0-3.91,0-7.41.05-10.3v-.16h.17a9.82,9.82,0,0,0,1.1,0,.48.48,0,0,0,.29-.67.44.44,0,0,0-.3-.25,2.27,2.27,0,0,0-.47,0h-1l-3.17,0a17.17,17.17,0,0,0-2,0A.63.63,0,0,0,292,57.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.27,110.15v-5.52a.67.67,0,0,1,.66-.66h.25a.66.66,0,0,1,.65.66v.26h4.1v1.4h-4v3.86Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.94,111.26h10.29a.27.27,0,0,1,.27.27v17a.27.27,0,0,1-.27.27H237.94a.27.27,0,0,1-.27-.27v-17A.28.28,0,0,1,237.94,111.26Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.59,109h3.22a1.05,1.05,0,0,1,1.05,1.05v1.17a0,0,0,0,1,0,0h-5.33a0,0,0,0,1,0,0v-1.17A1.05,1.05,0,0,1,241.59,109Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.8,
    y: 113.99,
    width: 4.7,
    height: 11.6,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,111.2a10.75,10.75,0,0,1-2.73.17,10.86,10.86,0,0,1-2.74-.17,11.45,11.45,0,0,1,2.74-.17A11.33,11.33,0,0,1,245.87,111.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33,122.79a37.36,37.36,0,0,1-.17-5.11,37.36,37.36,0,0,1,.17-5.11,39.39,39.39,0,0,1,.17,5.11A39.39,39.39,0,0,1,238.33,122.79Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.63,110.15v-5.52a.66.66,0,0,1,.66-.66h.24a.66.66,0,0,1,.66.66v.26h4.1v1.4h-4v3.86Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,111.26h10.29a.27.27,0,0,1,.27.27v17a.27.27,0,0,1-.27.27H222.29a.27.27,0,0,1-.27-.27v-17A.28.28,0,0,1,222.29,111.26Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,109h3.22a1.05,1.05,0,0,1,1.05,1.05v1.17a0,0,0,0,1,0,0H224.9a0,0,0,0,1,0,0v-1.17A1.05,1.05,0,0,1,226,109Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.16,
    y: 113.99,
    width: 4.7,
    height: 11.6,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23,111.2a22.09,22.09,0,0,1-5.47,0,22.09,22.09,0,0,1,5.47,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,122.79a37.36,37.36,0,0,1-.17-5.11,37.36,37.36,0,0,1,.17-5.11,39.39,39.39,0,0,1,.17,5.11A39.39,39.39,0,0,1,222.69,122.79Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.63,110.15v-5.52a.67.67,0,0,1,.66-.66h.25a.67.67,0,0,1,.66.66v.26h4.09v1.4h-4v3.86Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.3,111.26h10.29a.27.27,0,0,1,.27.27v17a.27.27,0,0,1-.27.27H205.3a.27.27,0,0,1-.27-.27v-17A.28.28,0,0,1,205.3,111.26Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,109h3.22a1.05,1.05,0,0,1,1.05,1.05v1.17a0,0,0,0,1,0,0H207.9a0,0,0,0,1,0,0v-1.17A1.05,1.05,0,0,1,209,109Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.16,
    y: 113.99,
    width: 4.7,
    height: 11.6,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.23,111.2a22,22,0,0,1-5.46,0,22,22,0,0,1,5.46,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,122.79a39.39,39.39,0,0,1-.17-5.11,39.39,39.39,0,0,1,.17-5.11,39.39,39.39,0,0,1,.17,5.11A39.39,39.39,0,0,1,205.69,122.79Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.13,113.2c0,4.13,0,10.8,0,13.87a1.63,1.63,0,0,0,1.63,1.63l11.28,0a1.64,1.64,0,0,0,1.65-1.63l0-13.75a3.63,3.63,0,0,0-3.63-3.64h0v-2l-7.39,0v1.91h0A3.64,3.64,0,0,0,306.13,113.2Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.13,113.2a3.39,3.39,0,0,1,0-.37,3.63,3.63,0,0,1,1.32-2.5,3.77,3.77,0,0,1,2.24-.84l-.08.09c0-.59,0-1.23,0-1.91v-.1h.1l7.39,0h.13v2.16l-.14-.14a3.8,3.8,0,0,1,1.82.47,3.81,3.81,0,0,1,2,3.31v2c0,2.75,0,5.65,0,8.65v2.56a4.46,4.46,0,0,1,0,.88,1.83,1.83,0,0,1-1.16,1.31,2.41,2.41,0,0,1-.87.1h-.82l-6.25,0-2.92,0h-.7a3,3,0,0,1-.72-.05,1.77,1.77,0,0,1-1.13-.86,1.82,1.82,0,0,1-.22-.67c0-.25,0-.45,0-.66,0-.43,0-.85,0-1.26,0-.83,0-1.62,0-2.37,0-3,.05-5.44.06-7.15,0-.82,0-1.47,0-1.94l0-.5a1.23,1.23,0,0,1,0-.18s0,.06,0,.18v.5c0,.47,0,1.12,0,1.94,0,1.71,0,4.15.05,7.15v2.37c0,.41,0,.83,0,1.26,0,.2,0,.44,0,.63a1.46,1.46,0,0,0,.18.57,1.53,1.53,0,0,0,1,.73,3.44,3.44,0,0,0,.66,0h10.69a1.93,1.93,0,0,0,.77-.08,1.47,1.47,0,0,0,1-1.08,4.19,4.19,0,0,0,0-.81v-.85c0-.56,0-1.14,0-1.71,0-3,0-5.9,0-8.66,0-.68,0-1.36,0-2a3.52,3.52,0,0,0-3.48-3.51h-.14v-.13c0-.71,0-1.39,0-2l.14.13-7.39,0,.1-.1c0,.68,0,1.32,0,1.91v.08h-.08a3.54,3.54,0,0,0-2.16.77,3.59,3.59,0,0,0-1.06,1.35A4.67,4.67,0,0,0,306.13,113.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.78 107.92 309.78 108.84 316.92 109.12 316.92 107.94 309.78 107.92",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.51,104.86h5.8a1.65,1.65,0,0,1,1.65,1.65v1.42a.59.59,0,0,1-.59.59h-7.93a.59.59,0,0,1-.59-.59v-1.42a1.65,1.65,0,0,1,1.65-1.65Z",
    transform: "translate(0.26 -0.75) rotate(0.14)",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,108.53a8.06,8.06,0,0,1-.1-1.82,9.81,9.81,0,0,1,.1-1.83,8.12,8.12,0,0,1,.1,1.83A9.74,9.74,0,0,1,310,108.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,108.53a8.38,8.38,0,0,1-.09-1.82,8.12,8.12,0,0,1,.1-1.83,9.36,9.36,0,0,1,.09,1.83A8.74,8.74,0,0,1,311,108.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,108.54a9.36,9.36,0,0,1-.09-1.83,8.88,8.88,0,0,1,.1-1.83,8.51,8.51,0,0,1,.09,1.83A8.12,8.12,0,0,1,312,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.94,108.54a8.12,8.12,0,0,1-.1-1.83,9.65,9.65,0,0,1,.1-1.82,8,8,0,0,1,.1,1.82A9.81,9.81,0,0,1,312.94,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,108.54a8.51,8.51,0,0,1-.09-1.83,8.06,8.06,0,0,1,.1-1.82,9.36,9.36,0,0,1,.09,1.83A8.82,8.82,0,0,1,313.91,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,108.54a9.3,9.3,0,0,1-.09-1.82,8.88,8.88,0,0,1,.1-1.83,8.51,8.51,0,0,1,.09,1.83A8,8,0,0,1,314.88,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,108.54a8,8,0,0,1-.1-1.82,9.81,9.81,0,0,1,.1-1.83,8.12,8.12,0,0,1,.1,1.83A9.65,9.65,0,0,1,315.86,108.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.83,108.55a8.51,8.51,0,0,1-.09-1.83,8,8,0,0,1,.1-1.82,9.21,9.21,0,0,1,.09,1.82A8.88,8.88,0,0,1,316.83,108.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 115.21,
    width: 10.58,
    height: 7,
    rx: 1.48,
    transform: "translate(0.29 -0.76) rotate(0.14)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.05,121.74a.87.87,0,0,0,0-.11v-.33c0-.3,0-.71,0-1.23,0-1.07,0-2.57,0-4.4l.08.07h-9.28l.1-.1h0v3.12c0,1,0,2,0,2.93l-.09-.09,6.66.06,1.92,0h.7s-.05,0-.16,0h-.5l-1.9,0-6.72,0h-.08v-6.16h0c-.09.09.12-.12.1-.09l9.28,0h.07v.08c0,1.85,0,3.37-.05,4.45,0,.51,0,.91,0,1.21,0,.13,0,.23,0,.31A.28.28,0,0,1,318.05,121.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,117.63a27.81,27.81,0,0,1-3.16.09,24.83,24.83,0,0,1-3.15-.11,49.83,49.83,0,0,1,6.31,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.62,118.7a27.56,27.56,0,0,1-3.15.09,26.12,26.12,0,0,1-3.15-.1,23,23,0,0,1,3.15-.09A26.12,26.12,0,0,1,316.62,118.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.62,119.73a27.56,27.56,0,0,1-3.15.09,26.12,26.12,0,0,1-3.15-.1,23,23,0,0,1,3.15-.09A26.12,26.12,0,0,1,316.62,119.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.66,109.64a27.37,27.37,0,0,1-3.44.09,31.14,31.14,0,0,1-3.44-.1,27.37,27.37,0,0,1,3.44-.09A31.14,31.14,0,0,1,316.66,109.64Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.73,126.27a5.59,5.59,0,0,1,0-.65c0-.45,0-1.05,0-1.77,0-1.5,0-3.57,0-5.85,0-1.14,0-2.23,0-3.22a6.46,6.46,0,0,1,.44-2.61,2.8,2.8,0,0,1,1.17-1.33,1.87,1.87,0,0,1,.45-.18.72.72,0,0,1,.17,0,5.2,5.2,0,0,0-.58.27,2.87,2.87,0,0,0-1.09,1.33,6.47,6.47,0,0,0-.38,2.55c0,1,0,2.08,0,3.22,0,2.28,0,4.35-.06,5.85,0,.72,0,1.32,0,1.77A4.21,4.21,0,0,1,306.73,126.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.16,128.21l-.51-.16-.58-.2c-.23-.07-.49-.16-.79-.23a16.25,16.25,0,0,0-2.08-.44,20.66,20.66,0,0,0-2.6-.2,19,19,0,0,0-2.6.19,18.33,18.33,0,0,0-2.08.43c-.3.07-.56.16-.79.23a5.93,5.93,0,0,0-.59.19,3.44,3.44,0,0,1-.51.16,2.88,2.88,0,0,1,.48-.23c.16-.07.35-.15.58-.23s.49-.17.79-.25A15.58,15.58,0,0,1,311,127a17,17,0,0,1,5.26,0,15.84,15.84,0,0,1,2.09.49c.29.08.55.18.78.26s.43.16.58.23A2.09,2.09,0,0,1,320.16,128.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,44.09l-1.19,0-3.41,0-13,.06-46.5.11.21-.22c0,24,0,53.26.05,84.82h0l-.26-.26,64.07,0-.24.24c.05-25.11.09-46.28.12-61.2,0-7.46.05-13.35.06-17.4q0-3,0-4.62c0-.51,0-.91,0-1.19s0-.42,0-.42,0,.13,0,.39,0,.66,0,1.17c0,1.05,0,2.58,0,4.57,0,4,0,9.91.07,17.35,0,15,.06,36.18.11,61.35v.23h-.23l-64.07,0h-.26v-.26h0c0-31.56,0-60.84,0-84.82v-.21h.21l46.64.11,12.91.06,3.38,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.77,44.21a19.32,19.32,0,0,1-3.12-3.2,19.4,19.4,0,0,1-2.72-3.54,18.88,18.88,0,0,1,3.12,3.2A19.4,19.4,0,0,1,192.77,44.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.65,37.4a30.42,30.42,0,0,1-3.56,3.27c-2,1.76-3.35,3.42-3.48,3.32a12.75,12.75,0,0,1,3.14-3.71A17.86,17.86,0,0,1,263.65,37.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,129.57a18.26,18.26,0,0,1-2.34,3.69,19.28,19.28,0,0,1-2.76,3.4,18.17,18.17,0,0,1,2.34-3.7A18.06,18.06,0,0,1,192,129.57Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,137.12a52.37,52.37,0,0,1-3.84-4,50.5,50.5,0,0,1-3.77-4.1,21.62,21.62,0,0,1,4.15,3.74A21.79,21.79,0,0,1,263.88,137.12Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,136.13c-.14,0-.26-22-.26-49.17s.12-49.17.26-49.17.26,22,.26,49.17S263.63,136.13,263.49,136.13Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "coat-stand"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.59,
    y: 141.35,
    width: 85.02,
    height: 15.08,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.34,141.35a10,10,0,0,1-1.09.42c-.71.25-1.76.56-3.06.91a49.78,49.78,0,0,0-10,3.3,53.67,53.67,0,0,1-5.3,2.36,13.92,13.92,0,0,1-4.67.85,8.69,8.69,0,0,1-3.14-.59,5.4,5.4,0,0,1-1-.54s.37.2,1.07.47a9.33,9.33,0,0,0,3.11.51,13.85,13.85,0,0,0,4.6-.88,54.68,54.68,0,0,0,5.28-2.37,47.27,47.27,0,0,1,10-3.25c1.31-.33,2.36-.62,3.08-.84l.82-.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,156.69a6.6,6.6,0,0,0-.45-1.73,6.26,6.26,0,0,0-3-3,10.46,10.46,0,0,0-4.22-.85c-.55,0-1,0-1.32,0a3,3,0,0,1-.48,0,1.42,1.42,0,0,1,.48-.08,12.2,12.2,0,0,1,1.32-.09,9.88,9.88,0,0,1,4.31.81,6.07,6.07,0,0,1,3,3.1,4,4,0,0,1,.32,1.29A1.53,1.53,0,0,1,395.31,156.69Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,156.18a1.37,1.37,0,0,0,.46-.25,1.75,1.75,0,0,0,.52-1.35,4.09,4.09,0,0,0-1-2.11c-.57-.74-1.18-1.62-1.85-2.6a24,24,0,0,0-5.36-6.23,9.65,9.65,0,0,0-4.43-1.84,7.28,7.28,0,0,0-4.91,1.29c-1.51,1-2.8,2.18-4.26,3.09a16.31,16.31,0,0,1-4.54,1.86c-3,.79-5.83,1.26-7.92,2.36a5.53,5.53,0,0,0-2.3,2.08,3.52,3.52,0,0,0-.36,2.3,2.58,2.58,0,0,0,1,1.68,1.6,1.6,0,0,1-.43-.32,2.57,2.57,0,0,1-.69-1.34,3.52,3.52,0,0,1,.34-2.37,5.58,5.58,0,0,1,2.33-2.16c2.12-1.13,4.93-1.62,7.94-2.41A16.28,16.28,0,0,0,413,146c1.44-.9,2.73-2.11,4.26-3.09a7.41,7.41,0,0,1,5.05-1.32,9.86,9.86,0,0,1,4.51,1.88c2.56,1.89,4,4.38,5.37,6.31.66,1,1.26,1.86,1.82,2.61a4.08,4.08,0,0,1,1,2.17,1.73,1.73,0,0,1-.58,1.39A.87.87,0,0,1,434,156.18Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.7,156.4a.89.89,0,0,0,.33-.09,1,1,0,0,0,.48-.82,2.73,2.73,0,0,0-.59-1.44c-.33-.54-.7-1.15-1.15-1.8a10.53,10.53,0,0,0-3.95-3.74c-1.88-.93-4.29-.75-6.58-.11a59.2,59.2,0,0,0-11.43,4.6,10.92,10.92,0,0,0-3,2.19,9,9,0,0,0-.82,1.1,4.49,4.49,0,0,1,.76-1.15,10.48,10.48,0,0,1,3-2.27,57,57,0,0,1,11.44-4.67,14.3,14.3,0,0,1,3.5-.54,7.36,7.36,0,0,1,3.23.67,10.6,10.6,0,0,1,4,3.84c.45.66.81,1.28,1.13,1.82a2.76,2.76,0,0,1,.57,1.51,1,1,0,0,1-.54.85A.49.49,0,0,1,430.7,156.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.42,156.37s.17-.18.38-.55a3.09,3.09,0,0,0,.43-1.72,2.89,2.89,0,0,0-1.14-2.27,3.17,3.17,0,0,0-3.06-.31,4.16,4.16,0,0,0-1.31,1,2.76,2.76,0,0,1-1.43.79,11.7,11.7,0,0,0-1.4.31,3.39,3.39,0,0,0-1.05.64,7.56,7.56,0,0,0-1.19,1.37c-.25.35-.38.55-.39.54s0-.06.07-.16l.26-.43a6.65,6.65,0,0,1,1.15-1.43,3.39,3.39,0,0,1,1.09-.69,14.06,14.06,0,0,1,1.42-.34,2.59,2.59,0,0,0,1.33-.75,4.22,4.22,0,0,1,1.36-1.09,3.37,3.37,0,0,1,3.26.34,3,3,0,0,1,1.18,2.43,3.13,3.13,0,0,1-.51,1.77A1.88,1.88,0,0,1,424.42,156.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.24,156.43s-.43-.12-1.21-.25a22.87,22.87,0,0,0-3.37-.23,26.45,26.45,0,0,1-5-.34,9,9,0,0,1-2.77-1.1,15.06,15.06,0,0,1-2.51-2c-3.12-3.06-5.88-5.88-7.89-7.91-1-1-1.74-1.77-2.37-2.42l-.64-.66a1.16,1.16,0,0,1-.21-.24,1.62,1.62,0,0,1,.24.21l.66.64,2.42,2.37,7.93,7.86a10.82,10.82,0,0,0,5.19,3,26.85,26.85,0,0,0,5,.38,20.05,20.05,0,0,1,3.38.3A6.12,6.12,0,0,1,454.24,156.43Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.15,146.14a12.23,12.23,0,0,1,2.52,0,15.9,15.9,0,0,1,6.72,2l.19.1-.22,0a55.1,55.1,0,0,1-14.46-.71,2.65,2.65,0,0,1-1.8-1.23,1.55,1.55,0,0,1-.15-1.14,1.6,1.6,0,0,1,.71-.92,4.64,4.64,0,0,1,2.24-.6c.77-.06,1.55-.09,2.34-.1a38.25,38.25,0,0,1,9.78,1.19,35.94,35.94,0,0,1,4.19,1.35,13.37,13.37,0,0,1,2,.89,1.92,1.92,0,0,1,.75.82,1.36,1.36,0,0,1,0,1.1,2.31,2.31,0,0,1-1.66,1.28,15.88,15.88,0,0,1-2,.26c-1.34.12-2.66.2-3.94.25-2.57.1-5,.08-7.3,0a30.43,30.43,0,0,1-6.3-.9,14.1,14.1,0,0,1-7.71-4.8,9.66,9.66,0,0,1-1.27-2.15,6.22,6.22,0,0,1-.29-.82,2,2,0,0,1,.08.2c.06.14.13.34.25.6a10,10,0,0,0,1.3,2.12,14,14,0,0,0,7.68,4.71,31.61,31.61,0,0,0,6.27.87c2.27.11,4.72.13,7.28,0,1.28,0,2.59-.14,3.93-.26a14.78,14.78,0,0,0,2-.26,2.07,2.07,0,0,0,1.52-1.16,1.14,1.14,0,0,0,0-.94,1.66,1.66,0,0,0-.67-.72,12.21,12.21,0,0,0-1.94-.88,37.4,37.4,0,0,0-4.16-1.34,38.3,38.3,0,0,0-9.72-1.19c-.79,0-1.57,0-2.34.1a4.4,4.4,0,0,0-2.14.56,1.34,1.34,0,0,0-.5,1.81,2.46,2.46,0,0,0,1.67,1.14,55.87,55.87,0,0,0,14.41.76l0,.12a16,16,0,0,0-6.66-2.06,18.42,18.42,0,0,0-1.87,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.57,151.7a3.12,3.12,0,0,1-.28.36c-.19.22-.48.53-.86.89a12.38,12.38,0,0,1-7.37,3.32,8.31,8.31,0,0,1-1.24,0,1.38,1.38,0,0,1-.46,0s.65,0,1.68-.16a14,14,0,0,0,3.9-1.09,13.8,13.8,0,0,0,3.39-2.2C470.11,152.16,470.54,151.67,470.57,151.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.21,
    y: 137.83,
    width: 4.99,
    height: 12.96,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.2,
    y: 137.83,
    width: 4.99,
    height: 12.96,
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "flasks",
    "data-motion": "float",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.94,233.43v1.37h1.9v12.43l-7.49,16.65a2.85,2.85,0,0,0,2.59,4h14.9a2.84,2.84,0,0,0,2.59-4l-7.78-17.18V234.88h1.83v-1.45Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.94,233.43h2.21l6.33,0h.05v1.56h-1.88l.06-.06c0,3.32,0,7.33,0,11.82v0c1.64,3.62,3.45,7.6,5.38,11.84l1.46,3.22.75,1.65a6,6,0,0,1,.35.86,3,3,0,0,1,.12.94,3,3,0,0,1-.68,1.75,2.89,2.89,0,0,1-1.62,1l-.24.05H230a3.89,3.89,0,0,1-.48,0H215.31a4,4,0,0,1-1.23-.13,3,3,0,0,1-1.8-1.57,2.92,2.92,0,0,1-.05-2.35c.31-.71.63-1.4.94-2.09l6.61-14.64v0c0-5.51,0-9.8,0-12.43l0,0h-1.92v-1.07c0-.22,0-.33,0-.33s0,.12,0,.35v1l0,0h1.94v0c0,2.63,0,6.92,0,12.43v0h0c-1.89,4.2-4.12,9.16-6.58,14.66-.31.69-.63,1.39-.93,2.09a2.73,2.73,0,0,0,1.74,3.67,3.48,3.48,0,0,0,1.17.12h14.21a3.65,3.65,0,0,0,.47,0h.23l.22,0a2.71,2.71,0,0,0,1.52-.92,2.85,2.85,0,0,0,.63-1.64,2.91,2.91,0,0,0-.11-.88,7.25,7.25,0,0,0-.34-.83l-.75-1.65-1.46-3.23-5.36-11.85h0v0c0-4.49,0-8.5,0-11.82v-.06h1.89l-.06.06v-1.45l.06,0-6.3,0-1.66,0h-.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,260.51a2.49,2.49,0,0,1,2.5-1.51h0a14.2,14.2,0,0,0,2.43.18,10.87,10.87,0,0,0,3.88-1.65c1.26-.66,2.82-1.11,4.06-.43l3.15,6.26a2.17,2.17,0,0,1-1.95,3.15H215.83a2.18,2.18,0,0,1-2-3Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.72,258.38a6.39,6.39,0,0,0-1.55.85c-.45.33-.94.77-1.52,1.22a5.08,5.08,0,0,1-2.15,1.08,6.3,6.3,0,0,1-2.4-.14c-.72-.17-1.35-.36-1.89-.5l-1.27-.35a2.32,2.32,0,0,1-.45-.16l.47.08,1.28.3c.54.13,1.18.3,1.9.45a6,6,0,0,0,2.33.13,4.93,4.93,0,0,0,2.07-1c.58-.44,1.09-.87,1.55-1.19a4.89,4.89,0,0,1,1.16-.63c.15-.06.27-.07.35-.1Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.22,275.69a6.38,6.38,0,0,0-3.59-4.55,1,1,0,0,0-1,0,1.09,1.09,0,0,0-.26.81c-.06,1.37-.11,2.73-.17,4.1a2.8,2.8,0,0,0-.74-1.45,1,1,0,0,0-1.43.16c-.19.39,0,.85.17,1.26a3.78,3.78,0,0,1-1,4c-.75.67-1.75,1-2.54,1.64a4.13,4.13,0,0,0,1.76,7.25h2.7c1.56,0,3.39-1.54,4.37-2.76a12.4,12.4,0,0,0,2-4.42A12.75,12.75,0,0,0,229.22,275.69Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.22,275.69a6.38,6.38,0,0,0-3.59-4.55,1,1,0,0,0-1,0,1.09,1.09,0,0,0-.26.81c-.06,1.37-.11,2.73-.17,4.1a2.8,2.8,0,0,0-.74-1.45,1,1,0,0,0-1.43.16c-.19.39,0,.85.17,1.26a3.78,3.78,0,0,1-1,4c-.75.67-1.75,1-2.54,1.64a4.13,4.13,0,0,0,1.76,7.25h2.7c1.56,0,3.39-1.54,4.37-2.76a12.4,12.4,0,0,0,2-4.42A12.75,12.75,0,0,0,229.22,275.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.72,288.91a3.92,3.92,0,0,1-1.81-3.18,3.53,3.53,0,0,1,1.52-2.58c.9-.64,2.18-.7,2.95-1.51a9.07,9.07,0,0,0,1.1-2.28,1.34,1.34,0,0,1,1.14-.85c.59.05.92.72,1,1.3.37,1.65.55,3.9,0,5.11-.72,1.53-1.65,3.42-3.59,4",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.25,275.15a.75.75,0,0,0-.47-.23h-.13a.69.69,0,0,0-.71.77.67.67,0,0,0,.52.58.81.81,0,0,0,.76-.23.74.74,0,0,0,.21-.41A.64.64,0,0,0,227.25,275.15Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.52,
    y: 288.64,
    width: 3.78,
    height: 9.43,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,301.76h0a2.52,2.52,0,0,1,2.52-2.52h9.43a2.52,2.52,0,0,1,2.52,2.52H215.19Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,299.24h-9.63a1.34,1.34,0,0,1,1.33-1.33h7a1.33,1.33,0,0,1,1.33,1.33Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,237.76c0,.05-5.63.09-12.58.09s-12.59,0-12.59-.09,5.64-.1,12.59-.1S240,237.71,240,237.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,301.07c-.06,0-.1-15.23-.1-34s0-34,.1-34,.09,15.22.09,34S240.67,301.07,240.62,301.07Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,301.65a3.76,3.76,0,0,0-3.76-3.77h0a3.77,3.77,0,0,0-3.77,3.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,235.87a1.89,1.89,0,0,0-1.89,1.89h0a1.89,1.89,0,0,0,1.89,1.88Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,271.59h0a.79.79,0,0,0,.79.82h.75v20a2.28,2.28,0,0,0,2.29,2.29h0a2.29,2.29,0,0,0,2.29-2.29V272.43h.71a.81.81,0,0,0,.81-.81h0a.8.8,0,0,0-.8-.8h-6.05A.8.8,0,0,0,272.53,271.59Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,271.59a.5.5,0,0,1,0-.18.83.83,0,0,1,.31-.46.86.86,0,0,1,.38-.14h1.7l3.31,0h1a1,1,0,0,1,.53.1.87.87,0,0,1,.06,1.5,1,1,0,0,1-.6.14h-.6l.08-.07c0,5.13,0,11.9,0,19.3v.6a2.54,2.54,0,0,1-.07.61,2.26,2.26,0,0,1-.58,1.06,2.3,2.3,0,0,1-1,.64,2.36,2.36,0,0,1-1.18.07,2.31,2.31,0,0,1-1.06-.5,2.44,2.44,0,0,1-.69-.93,2.68,2.68,0,0,1-.17-1.12v-1.08c0-2.88,0-5.56,0-8,0-4.82,0-8.58,0-10.69l0,0c-.34,0-.62,0-.88,0a.78.78,0,0,1-.53-.34.7.7,0,0,1-.13-.49.94.94,0,0,0,.16.47.73.73,0,0,0,.51.31c.24,0,.54,0,.87,0h0v0c0,2.11,0,5.87,0,10.69,0,2.42,0,5.1,0,8v1.08a2.47,2.47,0,0,0,.17,1,2.21,2.21,0,0,0,.63.86,2.35,2.35,0,0,0,1,.46,2.24,2.24,0,0,0,1.09-.07,2.18,2.18,0,0,0,.94-.59,2.23,2.23,0,0,0,.53-1,5.5,5.5,0,0,0,.06-1.16c0-7.4,0-14.17,0-19.3v-.07h.68a.85.85,0,0,0,.52-.12.75.75,0,0,0,.28-.9.8.8,0,0,0-.33-.37.85.85,0,0,0-.47-.09h-1l-3.31,0h-1.69a.71.71,0,0,0-.37.13.84.84,0,0,0-.31.42A1.32,1.32,0,0,1,272.53,271.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.33,293.92h0a1.72,1.72,0,0,1-1.71-1.72V278.91H278V292.2A1.71,1.71,0,0,1,276.33,293.92Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,272.47a8.47,8.47,0,0,1-1.74.09,8.33,8.33,0,0,1-1.73-.09,7.23,7.23,0,0,1,1.73-.1A7.35,7.35,0,0,1,278,272.47Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.62,278.91a.61.61,0,0,1,.5-.52,2.34,2.34,0,0,1,.87.05l1.68.24a.56.56,0,0,1,.31.12c.08.08.1.24,0,.3",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.21
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.25,280.87a.52.52,0,1,1-.52-.52A.51.51,0,0,1,276.25,280.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.21
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 283.18,
    r: 0.26,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.35,271.59h0a.8.8,0,0,0,.79.82h.75v20a2.28,2.28,0,0,0,2.29,2.29h0a2.29,2.29,0,0,0,2.29-2.29V272.43h.71a.81.81,0,0,0,.81-.81h0a.8.8,0,0,0-.8-.8h-6.05A.8.8,0,0,0,284.35,271.59Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.35,271.59a.5.5,0,0,1,0-.18.83.83,0,0,1,.31-.46.86.86,0,0,1,.38-.14h1.7l3.31,0h1a1,1,0,0,1,.53.1.87.87,0,0,1,.06,1.5,1,1,0,0,1-.6.14h-.59l.07-.07c0,5.13,0,11.9,0,19.3v.6a2.54,2.54,0,0,1-.07.61,2.24,2.24,0,0,1-.57,1.06,2.39,2.39,0,0,1-1,.64,2.38,2.38,0,0,1-2.24-.43,2.32,2.32,0,0,1-.68-.93,2.69,2.69,0,0,1-.18-1.12v-1.08c0-2.88,0-5.56,0-8,0-4.82,0-8.58,0-10.69l0,0c-.34,0-.62,0-.88,0a.79.79,0,0,1-.66-.83.94.94,0,0,0,.16.47.73.73,0,0,0,.51.31c.24,0,.54,0,.87,0h0v0c0,2.11,0,5.87.05,10.69,0,2.42,0,5.1,0,8v1.08a2.47,2.47,0,0,0,.17,1,2.17,2.17,0,0,0,1.61,1.32,2.25,2.25,0,0,0,1.09-.07,2.14,2.14,0,0,0,.93-.59,2.23,2.23,0,0,0,.53-1,5.5,5.5,0,0,0,.06-1.16c0-7.4,0-14.17,0-19.3v-.07h.68a.84.84,0,0,0,.52-.12.74.74,0,0,0,0-1.27.85.85,0,0,0-.47-.09h-1l-3.31,0h-1.69a.71.71,0,0,0-.37.13.84.84,0,0,0-.31.42A1.32,1.32,0,0,1,284.35,271.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.15,293.92h0a1.72,1.72,0,0,1-1.71-1.72V278.91h3.42V292.2A1.71,1.71,0,0,1,288.15,293.92Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.03,
    cy: 272.47,
    rx: 1.73,
    ry: 0.1,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.44,278.91a.61.61,0,0,1,.5-.52,2.34,2.34,0,0,1,.87.05l1.68.24a.56.56,0,0,1,.31.12.19.19,0,0,1,0,.3",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.21
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.07,280.87a.52.52,0,1,1-.52-.52A.51.51,0,0,1,288.07,280.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.21
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 287.83,
    cy: 283.18,
    r: 0.26,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.73,291.77c-.26,0-.47-1.43-.47-3.19s.21-3.2.47-3.2.48,1.43.48,3.2S276,291.77,275.73,291.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.39,291.77c-.27,0-.48-1.43-.48-3.19s.21-3.2.48-3.2.48,1.43.48,3.2S287.65,291.77,287.39,291.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.5,270.83c.06,0,.1,6.81.1,15.21s0,15.21-.1,15.21-.09-6.81-.09-15.21S264.45,270.83,264.5,270.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,270.86c.05,0,.1,6.81.1,15.21s-.05,15.21-.1,15.21-.1-6.8-.1-15.21S308.79,270.86,308.84,270.86Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.88,276.21c0,.05-10,.1-22.31.1s-22.32-.05-22.32-.1,10-.09,22.32-.09S308.88,276.16,308.88,276.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.27,301.65a3.77,3.77,0,0,0-3.77-3.77h0a3.76,3.76,0,0,0-3.76,3.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.61,301.76a3.76,3.76,0,0,0-3.77-3.76h0a3.76,3.76,0,0,0-3.77,3.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.25,278.53a1.89,1.89,0,0,0,1.89-1.89h0a1.89,1.89,0,0,0-1.89-1.88Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.88,274.76a1.88,1.88,0,0,0-1.88,1.88h0a1.89,1.89,0,0,0,1.88,1.89Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.65,265.29h-1.57l-4.52,0-16.62,0h-8.43c-.5,0-1,0-1.5,0a5.43,5.43,0,0,0-1.47.35,5.35,5.35,0,0,0-.7.31,6.4,6.4,0,0,0-.64.42,5.26,5.26,0,0,0-1.13,1.08,5.93,5.93,0,0,0-.8,1.36,6.39,6.39,0,0,0-.4,1.56c-.08,1.08,0,2.2-.08,3.34a11.92,11.92,0,0,1-.82,3.34,11.28,11.28,0,0,1-8.12,6.62,11.55,11.55,0,0,1-3.76.09A11.17,11.17,0,0,1,236.5,273V242.84c0-4.63,0-9,0-13.17a7,7,0,0,0-7.33-7,6.89,6.89,0,0,0-4.48,1.87,7.24,7.24,0,0,0-1.4,1.79,7.35,7.35,0,0,0-.72,2,9.76,9.76,0,0,0-.14,2v1.86c0,1.2,0,2.29,0,3.27,0,2,0,3.48,0,4.52,0,.51,0,.9,0,1.17s0,.4,0,.4,0-.14,0-.4,0-.66,0-1.17c0-1,0-2.56,0-4.52v-3.27c0-.59,0-1.22,0-1.86a10.76,10.76,0,0,1,.13-2,7.75,7.75,0,0,1,.73-2.05,7.41,7.41,0,0,1,1.42-1.82,7.05,7.05,0,0,1,4.55-1.92,7.19,7.19,0,0,1,7.5,7.16c0,4.13,0,8.54,0,13.17,0,9.28,0,19.48,0,30.19a11,11,0,0,0,9.43,10.66,11.48,11.48,0,0,0,3.7-.09,11.24,11.24,0,0,0,3.39-1.3,11.11,11.11,0,0,0,4.59-5.2,11.66,11.66,0,0,0,.82-3.3c.1-1.12,0-2.23.09-3.34a5.89,5.89,0,0,1,1.23-3,5.8,5.8,0,0,1,1.16-1.11,6.9,6.9,0,0,1,.67-.43,6.58,6.58,0,0,1,.72-.32,6.08,6.08,0,0,1,1.5-.36c.52,0,1,0,1.52,0h8.43l16.62,0,4.52,0h1.57Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,265.29a25.48,25.48,0,0,1,0,4.51,28.3,28.3,0,0,1,0-4.51Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,265.29a28.3,28.3,0,0,1,0,4.51,25.48,25.48,0,0,1,0-4.51Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,224.49l2.22,2.43a3.71,3.71,0,0,1,.82,3.56L180.63,259a5.4,5.4,0,0,0,5.19,6.93h15.79a5.73,5.73,0,0,0,5.47-7.41l-8.76-28.31a3.72,3.72,0,0,1,.88-3.68l2-2.06Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,224.49l15.22-.06h.15l-.1.11-1.52,1.56c-.25.28-.53.54-.76.84a3.63,3.63,0,0,0-.54,1,3.74,3.74,0,0,0,0,2.34c.25.79.5,1.61.76,2.44l3.34,10.77c1.19,3.84,2.46,7.91,3.77,12.16.17.53.33,1.07.5,1.6.08.27.17.54.25.81a7.66,7.66,0,0,1,.23.82,6.27,6.27,0,0,1,.16,1.73l-.06.43,0,.22-.05.21-.11.42-.15.42a5.79,5.79,0,0,1-5.57,3.73H185.83a5.52,5.52,0,0,1-5.51-5.71c0-.24.05-.48.07-.71s.11-.46.17-.69l.39-1.32c.25-.87.51-1.73.76-2.58l1.46-4.95,2.62-8.88c.8-2.71,1.53-5.16,2.16-7.32.32-1.07.62-2.08.9-3,.06-.23.13-.46.19-.68a5,5,0,0,0,.08-.66,3.72,3.72,0,0,0-.16-1.22,4,4,0,0,0-.48-1,8.26,8.26,0,0,0-.64-.76l-1-1.15-.84-.94.88.94,1,1.12a7.13,7.13,0,0,1,.64.75,3.69,3.69,0,0,1,.67,2.25,3.16,3.16,0,0,1-.08.68c-.05.23-.12.45-.19.69q-.41,1.38-.87,3l-2.14,7.33c-.8,2.72-1.67,5.69-2.6,8.89q-.7,2.38-1.45,4.94c-.25.85-.5,1.72-.76,2.59a11.23,11.23,0,0,0-.61,2.67,5.34,5.34,0,0,0,5.33,5.52h15.63a5.58,5.58,0,0,0,5.39-3.61l.15-.4.1-.41.05-.21,0-.21,0-.42a6.15,6.15,0,0,0-.15-1.66,8.19,8.19,0,0,0-.23-.81c-.08-.27-.17-.54-.25-.81-.17-.54-.33-1.07-.49-1.6-1.32-4.25-2.57-8.33-3.76-12.17s-2.3-7.45-3.32-10.78c-.26-.83-.51-1.64-.75-2.44a3.74,3.74,0,0,1,0-2.43,3.92,3.92,0,0,1,.56-1.05,10.47,10.47,0,0,1,.78-.84l1.52-1.56,0,.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,300.14s-.09-16.3-.09-36.4,0-36.41.09-36.41.1,16.3.1,36.41S175.7,300.14,175.64,300.14Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5,231.7c0,.06-7.09.1-15.85.1s-15.85,0-15.85-.1,7.1-.09,15.85-.09S208.5,231.65,208.5,231.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.91,242.1a9.71,9.71,0,0,1-4.73-.1c-1.48-.41-2.85-1.17-4.31-1.66a5.73,5.73,0,0,0-4.49,0l-5,18.17a4.6,4.6,0,0,0,4.43,5.82H201a4.59,4.59,0,0,0,4.43-5.8Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.41,301.76a3.76,3.76,0,0,0-3.77-3.76h0a3.76,3.76,0,0,0-3.76,3.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,234.29a2.39,2.39,0,0,0,2.39-2.38h0a2.39,2.39,0,0,0-2.39-2.39Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.94,224.79a3.3,3.3,0,0,1-.54.28,6.09,6.09,0,0,1-.65.29c-.26.1-.55.23-.89.33a11.28,11.28,0,0,1-1.1.32c-.4.12-.83.19-1.29.28a18.64,18.64,0,0,1-3,.24,17.24,17.24,0,0,1-3-.32c-.45-.1-.89-.18-1.28-.31a10.79,10.79,0,0,1-1.09-.35c-.34-.11-.62-.24-.88-.35a7,7,0,0,1-.65-.3,5,5,0,0,1-.53-.3,3.67,3.67,0,0,1,.57.23,6.48,6.48,0,0,0,.65.27,8.76,8.76,0,0,0,.88.32,11,11,0,0,0,1.09.33c.39.12.82.2,1.27.29a19.38,19.38,0,0,0,3,.3,20.9,20.9,0,0,0,3-.22c.46-.09.89-.15,1.28-.26s.77-.2,1.1-.3.63-.21.89-.3l.66-.25A4.86,4.86,0,0,1,200.94,224.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.62,262.62c0,.05-.34.1-.9-.09a3.84,3.84,0,0,1-1.86-1.66,5,5,0,0,1-.61-1.64,7.62,7.62,0,0,1-.07-2,29.18,29.18,0,0,1,.89-4.26c1.49-5.91,2.91-10.65,3.16-10.58s-.74,4.9-2.23,10.81a39.84,39.84,0,0,0-.94,4.12,7.55,7.55,0,0,0,0,1.77,5.16,5.16,0,0,0,.42,1.44,4,4,0,0,0,1.43,1.64C188.33,262.46,188.63,262.54,188.62,262.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.42,244.74a2.9,2.9,0,0,1-.47.23c-.31.13-.77.31-1.34.51a8.85,8.85,0,0,1-2.1.42,5.59,5.59,0,0,1-1.27-.09,7.18,7.18,0,0,1-1.3-.4c-.86-.37-1.62-.8-2.35-1.12a6.16,6.16,0,0,0-2-.57,3.72,3.72,0,0,0-1.39.12,4.61,4.61,0,0,1-.49.18s0,0,.11-.07l.35-.18a3.5,3.5,0,0,1,1.43-.19,6.36,6.36,0,0,1,2.07.54c.74.32,1.51.76,2.35,1.11a7.15,7.15,0,0,0,1.27.4,5.71,5.71,0,0,0,1.22.09,8.93,8.93,0,0,0,2.07-.37l1.35-.45A2.66,2.66,0,0,1,200.42,244.74Z",
    style: {
      fill: "#F6F9FC"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character-2",
    "data-motion": "breathe",
    "data-delay": 2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "312.66 443.14 308.44 478.7 316.35 478.42 320.04 443.14 312.66 443.14",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.52 443 344.03 478.84 351.93 478.56 352.9 443 345.52 443",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.57 443.14 385.79 478.7 377.88 478.42 374.2 443.14 381.57 443.14",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.24,
    y: 457.88,
    width: 68.19,
    height: 4.81,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.75,430.94l.7,18.42s-18.39,6.52-18.59,9.94l35.68.3.07-28.75Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.27,447.85a1.47,1.47,0,0,1,1,1.68,1.41,1.41,0,0,1-1.65,1,1.54,1.54,0,0,1-1.07-1.78,1.47,1.47,0,0,1,1.84-.87",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,459.59V457.3l-34.63.41a2.71,2.71,0,0,0-1.23,1.78Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.13,449.48c0,.17.89.25,1.75.82s1.33,1.3,1.49,1.23-.1-1.09-1.16-1.75S321.09,449.32,321.13,449.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,451.05c0,.17.72.47,1.32,1.21s.77,1.53.95,1.52.28-1-.48-1.91S317.36,450.88,317.36,451.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.22,455.58c.16,0,.4-.84-.05-1.81s-1.28-1.34-1.35-1.19.43.66.79,1.45S315.05,455.56,315.22,455.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.44,445.23c.07.16.88-.08,1.87,0s1.77.38,1.86.23-.65-.78-1.82-.84S321.35,445.09,321.44,445.23Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.79,441.26a3.28,3.28,0,0,0,1.8,0,7.88,7.88,0,0,0,2.92-1.14,1.94,1.94,0,0,0,.54-.42.76.76,0,0,0,.08-.94,1,1,0,0,0-.77-.4,2.32,2.32,0,0,0-.68.1,6.42,6.42,0,0,0-1.12.39,6.54,6.54,0,0,0-1.66,1.09c-.83.78-1.11,1.44-1,1.47s.48-.49,1.33-1.14a7.69,7.69,0,0,1,1.61-.91,6.51,6.51,0,0,1,1-.32c.38-.1.71-.1.81.07s0,.09,0,.2a2.43,2.43,0,0,1-.4.31,10.5,10.5,0,0,1-.95.55,10.61,10.61,0,0,1-1.75.67A13.35,13.35,0,0,0,320.79,441.26Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "338.63 441.89 338.57 445.98 321.32 445.89 321.34 442.19 338.63 441.89"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M389.42,451.07l-.71,18.42s18.4,6.53,18.6,9.94l-35.68.3L371.56,451Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.9,468a1.48,1.48,0,0,0-1,1.68,1.43,1.43,0,0,0,1.66,1,1.55,1.55,0,0,0,1.07-1.78,1.46,1.46,0,0,0-1.84-.88",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.63,479.73v-2.29l34.63.41a2.71,2.71,0,0,1,1.23,1.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,469.61c0,.18-.89.25-1.75.82s-1.33,1.3-1.5,1.23.11-1.09,1.17-1.75S389.08,469.45,389,469.61Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.81,471.18c0,.17-.72.47-1.32,1.21s-.77,1.53-.95,1.52-.28-1,.48-1.91S392.81,471,392.81,471.18Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,475.71c-.16,0-.4-.84.05-1.8s1.28-1.35,1.35-1.2-.43.66-.8,1.46S395.12,475.69,395,475.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.73,465.37c-.07.16-.88-.09-1.87,0s-1.77.37-1.86.22.65-.78,1.82-.84S388.82,465.23,388.73,465.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.38,461.4a3.35,3.35,0,0,1-1.8,0,8.14,8.14,0,0,1-1.89-.58,8.59,8.59,0,0,1-1-.55,2.44,2.44,0,0,1-.55-.43.76.76,0,0,1-.07-.93.93.93,0,0,1,.77-.4,2.22,2.22,0,0,1,.67.09,6.25,6.25,0,0,1,1.13.39,6.54,6.54,0,0,1,1.66,1.09c.83.78,1.11,1.44,1.05,1.47s-.48-.49-1.33-1.13a6.89,6.89,0,0,0-1.61-.91,7.76,7.76,0,0,0-1-.33c-.38-.1-.71-.1-.81.07s0,.09,0,.2a1.74,1.74,0,0,0,.4.31,10.5,10.5,0,0,0,.95.55,9.78,9.78,0,0,0,1.75.67A10.71,10.71,0,0,1,389.38,461.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.54 462.02 371.6 466.11 388.85 466.02 388.83 462.32 371.54 462.02"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "366.25 463.39 392.81 463.39 392.81 443.14 365.36 443 366.25 463.39",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.68,
    y: 443.93,
    width: 10.22,
    height: 35.8,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.14,
    y: 443.93,
    width: 10.22,
    height: 35.8,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.38,
    y: 302.88,
    width: 264.16,
    height: 141.05,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,301.92H456.12v8H157.78Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,301.92s0,.66,0,2,0,3.32,0,6l-.06-.06,298.33-.2h0l-.26.26v-8l.26.26-211.18-.11L181.17,302l-17.33,0-4.51,0-1.55,0,1.51,0,4.48,0,17.27,0,63.71-.08,211.37-.1h.26v8.53h-.27L157.78,310h-.06v-.05c0-2.71,0-4.72,0-6.05S157.78,301.92,157.78,301.92Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.88,384.93a2.47,2.47,0,0,1,.32-.58l1-1.6c.88-1.39,2.18-3.38,3.79-5.83,3.23-4.89,7.77-11.61,12.88-19S261.72,344,265.2,339.3c1.74-2.36,3.15-4.26,4.15-5.57l1.15-1.5a4.52,4.52,0,0,1,.43-.5,2.55,2.55,0,0,1-.34.57l-1.08,1.55-4,5.67c-3.4,4.78-8.08,11.39-13.2,18.74s-9.69,14-13,18.87c-1.63,2.38-3,4.32-3.93,5.73l-1.08,1.55A4.16,4.16,0,0,1,233.88,384.93Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8,410.17c-.11-.08,12.42-17.73,28-39.42s28.3-39.21,28.42-39.13-12.42,17.73-28,39.43S229.92,410.26,229.8,410.17Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.9,399.45a5.38,5.38,0,0,1,.59-1.07c.41-.67,1-1.63,1.79-2.8,1.55-2.33,3.76-5.52,6.32-8.95s5-6.45,6.79-8.6c.9-1.07,1.64-1.93,2.17-2.51a5.84,5.84,0,0,1,.86-.87,6.16,6.16,0,0,1-.7,1l-2.05,2.62c-1.72,2.2-4.1,5.25-6.65,8.67s-4.81,6.57-6.43,8.85l-1.93,2.7A5.32,5.32,0,0,1,251.9,399.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.95 228.11 281.37 236.56 291.64 237.43 293.46 231.71 284.95 228.11",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94,211s6.49-2.61,7.08-2.14a2.8,2.8,0,0,1,.6,2.79,2.85,2.85,0,0,1-1.15,1.43Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.07,208.61s2.65-2.67,9.18-1.65c5.63.89,7.85,4.13,7.8,5.33a18.9,18.9,0,0,1-.72,3.44,18,18,0,0,1-8.86,1.26c-5-.58-7.81-5.15-7.89-5.44a23.62,23.62,0,0,1,.49-2.94Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.07,208.61a16.5,16.5,0,0,1-.24,1.7c0,.27-.09.57-.12.9a2.09,2.09,0,0,0,0,.25.32.32,0,0,0,.07.18c.09.15.2.3.31.46a12.85,12.85,0,0,0,1.77,2,10.05,10.05,0,0,0,6.11,2.74,18.06,18.06,0,0,0,8.26-1.29l-.14.16c.05-.18.11-.37.16-.56a20.63,20.63,0,0,0,.49-2.22,5.24,5.24,0,0,0,.06-.54,1.52,1.52,0,0,0-.06-.47,3.75,3.75,0,0,0-.47-.91,8.18,8.18,0,0,0-3.15-2.56,16.26,16.26,0,0,0-6.85-1.48,11.78,11.78,0,0,0-4.66.84,9.33,9.33,0,0,0-1.53.85s.09-.14.32-.33a5.51,5.51,0,0,1,1.13-.7,11.12,11.12,0,0,1,4.74-1,16,16,0,0,1,7.06,1.42,8.56,8.56,0,0,1,3.36,2.7,4,4,0,0,1,.54,1.05,2,2,0,0,1,.09.65,5.7,5.7,0,0,1-.06.58,20.23,20.23,0,0,1-.51,2.28l-.16.58,0,.11-.11.05a18,18,0,0,1-8.52,1.3,10.46,10.46,0,0,1-6.32-3,12.55,12.55,0,0,1-1.75-2.06,5,5,0,0,1-.31-.49.6.6,0,0,1-.1-.31l0-.28c0-.34.11-.64.16-.91.12-.54.22-1,.29-1.24S297.05,208.6,297.07,208.61Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.43,217.14s1.37-1.12,1.29-1.81-5.14-3.22-5.14-3.22-8.67-2.14-9.57-2.28a12.54,12.54,0,0,0-3.52,1.12c-.69.34-.69,2.41-.69,2.41l-1.8,2.58s.6,3.35.77,4.81a19.9,19.9,0,0,0,1,3.7l-1,3.87s1.14,3.74,4.13,4.45a6.44,6.44,0,0,0,4.8-.91l3.19-6.72a1.6,1.6,0,0,0,.78-2.24l2.63-.12a1.37,1.37,0,0,0,1.5-.8,2.7,2.7,0,0,0,.28-1.82,4.87,4.87,0,0,0,2.29-1.11C305,218.3,303.43,217.14,303.43,217.14Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.16,217.2a34.22,34.22,0,0,1-5.92-1.73c-.81-.28-1.55-.54-2.27-.84a2.3,2.3,0,0,0-.93-.15l-.9,0a7,7,0,0,1-1.81-.09,5.7,5.7,0,0,1,1.8-.28c.28,0,.58,0,.92,0a2.45,2.45,0,0,1,1.12.15c.65.24,1.45.5,2.24.78A39.88,39.88,0,0,1,303.16,217.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.08,220.16a3.46,3.46,0,0,1-1.57.08c-1-.07-2.29-.33-3.72-.58s-2.76-.45-3.69-.7a3.82,3.82,0,0,1-1.48-.54,6.38,6.38,0,0,1,1.55.18c.94.15,2.25.3,3.71.54s2.74.58,3.68.73A7.43,7.43,0,0,1,302.08,220.16Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,223.1a7.53,7.53,0,0,1-6.71-.75c.06-.14,1.47.46,3.32.65S297.92,223,298,223.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,225.14a6.43,6.43,0,0,1-3.47,1.5,6.65,6.65,0,0,1-2.72,0c-.7-.17-1-.49-1-.54s.42.11,1.07.18a9.46,9.46,0,0,0,2.56-.14C295.33,225.77,296.82,225,296.89,225.14Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.33,215.73a17.81,17.81,0,0,0-1.67-2.25,12.39,12.39,0,0,0-5.86-3.14,13.2,13.2,0,0,0-6.67-.07,16.55,16.55,0,0,0-2.59,1.09s.18-.23.59-.51a7.5,7.5,0,0,1,1.89-.93,12.53,12.53,0,0,1,6.91-.09,11.9,11.9,0,0,1,6,3.4,7.46,7.46,0,0,1,1.16,1.77A1.9,1.9,0,0,1,313.33,215.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54,235l-4,9.69S272,256.1,274.3,259.2s4.7,7.33,9.51,7S309,258.85,309,258.85l13.18-8.36,0,36.11-1.56,14.89,64.83.81-.24-29.13.67-11.91L392,278.91l3.85,4.72.59,2h0l-2.74,1.26,4.38,14.63s15.82.24,18.8-3.66l.09-.12a16.11,16.11,0,0,0,2.43-14.79l-.85-2.58-11.43-24.25-.33-3.66L398,234a59.37,59.37,0,0,0-5.84-4.93c-1.72-1-16-9.06-16-9.06l-7.63-6.84-25.39,1.57-1.86,2.67s-15.45,1-17.74,1.91-13.42,9.29-13.42,9.29l-2.14,4.06-3.84,1.27-12.17,7.33.34-4.61Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,215.63a6.79,6.79,0,0,0-3,6.44c.61,4,5.46,26.06,5.46,26.06l4.56,13,5.11-16.1s7.9-13.78,8.6-16.44,2.85-10.74,1.42-12.28S347.11,215.63,347.11,215.63Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.07,218.93l-4.87,11.22,4.87,1.33-3.1,3.69s12.55,13.14,13.44,13.73-5.32-30-5.32-30",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.18,280.71c0,.09-1.07-.56-2.91-1A12.51,12.51,0,0,0,399,284.07c-1.18,1.5-1.61,2.64-1.7,2.59a2.38,2.38,0,0,1,.26-.8,10.29,10.29,0,0,1,1.14-2,12.22,12.22,0,0,1,13.66-4.55,10.63,10.63,0,0,1,2.12.92A2.56,2.56,0,0,1,415.18,280.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,276.15c0,.09-1-.15-2.59,0a9.59,9.59,0,0,0-5.53,2.46,9,9,0,0,0-2.54,5.46c-.19,1.58,0,2.58-.12,2.59s-.11-.23-.18-.69a9.16,9.16,0,0,1-.07-1.93,8.81,8.81,0,0,1,2.56-5.81,9.24,9.24,0,0,1,5.86-2.45,7.72,7.72,0,0,1,1.93.15C407.86,276,408.1,276.12,408.09,276.15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,251.92a17.31,17.31,0,0,1,0,4.76,30.33,30.33,0,0,1-.52,4.72,17.28,17.28,0,0,1,0-4.76A30.33,30.33,0,0,1,386.48,251.92Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.5,254.42a16.46,16.46,0,0,1-2.05,3.57,16.77,16.77,0,0,1-2.49,3.27A16.28,16.28,0,0,1,388,257.7,16.66,16.66,0,0,1,390.5,254.42Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.44,244.64a7.27,7.27,0,0,1,.32-2.17,22.63,22.63,0,0,1,1.88-4.95,21.74,21.74,0,0,1,3-4.37,6.76,6.76,0,0,1,1.58-1.51,49.9,49.9,0,0,0-4.09,6.12A50.84,50.84,0,0,0,387.44,244.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,228.48a20.72,20.72,0,0,1,.51,3.24c.25,2,.55,4.8.78,7.88s.36,5.89.37,7.92a18.87,18.87,0,0,1-.1,3.29,22,22,0,0,1-.26-3.28c-.12-2-.29-4.81-.52-7.89s-.46-5.71-.63-7.88A20.55,20.55,0,0,1,320.69,228.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.61,216s-.17.17-.49.48A6.09,6.09,0,0,0,345,218a6.85,6.85,0,0,0-.68,3,10.53,10.53,0,0,0,.21,1.94c.11.7.23,1.43.35,2.2a246.2,246.2,0,0,0,5.48,24.33l.21.75-.62-.49c-2.06-1.64-4.1-3.48-6.1-5.42-2.62-2.56-5-5.15-7.27-7.68l-.15-.16.14-.17q1.75-2.07,3.4-4l.17.4-7.28-.46-.3,0,.11-.27a49.66,49.66,0,0,1,3.78-7.32c1.26-2.1,2.43-3.88,3.4-5.33s1.77-2.57,2.32-3.33l.64-.86a1.69,1.69,0,0,1,.23-.28,1.21,1.21,0,0,1-.18.32l-.58.9L340,219.42c-.95,1.47-2.08,3.27-3.31,5.37a51,51,0,0,0-3.68,7.29l-.19-.29,7.28.41.48,0-.31.37-3.38,4.06v-.33c2.23,2.51,4.65,5.09,7.25,7.63,2,1.94,4,3.77,6.06,5.4l-.41.27a222.92,222.92,0,0,1-5.31-24.41l-.32-2.21a10.7,10.7,0,0,1-.17-2,6.91,6.91,0,0,1,.78-3.07,5.53,5.53,0,0,1,1.27-1.54l.4-.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.83,232.74a1.52,1.52,0,0,1-.11.31l-.4.87c-.36.76-.92,1.86-1.66,3.24-1.43,2.77-3.76,6.57-5.79,11.41l-.31-.3A63,63,0,0,0,369.45,241c.88-.71,1.81-1.41,2.57-2.16a2.38,2.38,0,0,0,.72-1.28,2,2,0,0,0-.45-1.34L368.93,231l-.31-.49.57.14L375,232l-.25.15a26.65,26.65,0,0,0,.93-9.29c-.09-1.11-.22-2-.31-2.57a6.06,6.06,0,0,1-.13-.91,3.84,3.84,0,0,1,.25.88,23,23,0,0,1,.43,2.58,25.72,25.72,0,0,1-.76,9.42l-.05.19-.2,0-5.83-1.36.27-.35c1.07,1.64,2.19,3.37,3.37,5.16a2.55,2.55,0,0,1,.53,1.69,2.91,2.91,0,0,1-.85,1.58c-.84.82-1.72,1.48-2.63,2.21a60.73,60.73,0,0,1-12,7.32l-.55.26.24-.56a114.3,114.3,0,0,1,6-11.37l1.77-3.16A8.92,8.92,0,0,1,365.83,232.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.72,240.33a2.9,2.9,0,0,1,.28.89c.15.57.34,1.41.54,2.45a43,43,0,0,1,.86,8.26,13.56,13.56,0,0,1-2.38,7.93,8,8,0,0,1-1.78,1.81,2.61,2.61,0,0,1-.8.47,14.6,14.6,0,0,0,2.28-2.49,14,14,0,0,0,2.16-7.72,54.06,54.06,0,0,0-.7-8.2A28.43,28.43,0,0,1,291.72,240.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,247.39a6,6,0,0,1,.86,2,15,15,0,0,1-.9,10.43,6.14,6.14,0,0,1-1.19,1.84,18.34,18.34,0,0,0,1.23-14.29Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,250.49a7,7,0,0,1-2.15-.73,23.2,23.2,0,0,1-4.68-2.87,29,29,0,0,1-4-3.8,7.44,7.44,0,0,1-1.33-1.84c.13-.11,2.28,2.61,5.62,5.23A44.52,44.52,0,0,0,322.21,250.49Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.88,275.83a17.05,17.05,0,0,0-2.68,4.51,16.87,16.87,0,0,0-.7,5.19,3.44,3.44,0,0,1-.33-1.56,9.86,9.86,0,0,1,.54-3.81,9.7,9.7,0,0,1,1.94-3.31C399.32,276.12,399.84,275.78,399.88,275.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.25,
    y: 248.46,
    width: 15.28,
    height: 4.23,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,250.8a62.22,62.22,0,0,1-11.58,0,64.6,64.6,0,0,1,11.58,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,198.07a64.88,64.88,0,0,0,3-10.84,22.75,22.75,0,0,0-.75-11.12c-.19-.53-1.84-4.13-2.4-4.08s.59,3.38.38,3.73A19.38,19.38,0,0,0,366.19,187a51,51,0,0,0,2.12,11.08",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.8,229.33a10.69,10.69,0,0,0,10.6-10.56l.45-35c.42-9.4-4.7-17.48-14.11-17.64l-.87,0a16.82,16.82,0,0,0-16.12,16.15c-.32,8.15-.57,17.16-.33,21.52.48,9,9.56,10.05,9.56,10.05s0,2.09,0,4.74a10.71,10.71,0,0,0,10.8,10.72Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,213.87a21.8,21.8,0,0,0,11.61-4s-2.55,6.9-11.58,6.46Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.64,189.13a1.3,1.3,0,0,0,1.3,1.25,1.24,1.24,0,0,0,1.28-1.22,1.3,1.3,0,0,0-1.3-1.25A1.24,1.24,0,0,0,340.64,189.13Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.83,186.21c.17.16,1.12-.61,2.5-.66s2.44.6,2.58.42-.11-.37-.56-.68a3.57,3.57,0,0,0-2.07-.54,3.41,3.41,0,0,0-2,.73C339.88,185.82,339.75,186.13,339.83,186.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,189.13a1.29,1.29,0,0,0,1.29,1.25,1.23,1.23,0,0,0,1.28-1.22,1.29,1.29,0,0,0-1.29-1.25A1.23,1.23,0,0,0,353.4,189.13Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.44,186c.17.16,1.11-.61,2.5-.66s2.43.6,2.58.42-.11-.37-.57-.68a3.55,3.55,0,0,0-2.07-.54,3.44,3.44,0,0,0-2,.73C353.49,185.58,353.36,185.89,353.44,186Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.91,196.83a9,9,0,0,0-2.27-.32c-.36,0-.7-.08-.77-.32a1.81,1.81,0,0,1,.2-1.06c.29-.87.61-1.78.93-2.73,1.3-3.9,2.22-7.1,2.06-7.15a47.82,47.82,0,0,0-2.63,7c-.31,1-.61,1.88-.89,2.76a2,2,0,0,0-.13,1.39.91.91,0,0,0,.61.5,2.76,2.76,0,0,0,.6.06A10.31,10.31,0,0,0,348.91,196.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.35,180.78c.2.34,1.53-.08,3.17-.19s3,.1,3.16-.27c.07-.18-.22-.49-.81-.75a5.52,5.52,0,0,0-4.82.35C353.5,180.27,353.26,180.61,353.35,180.78Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,183c.3.31,1.42,0,2.77-.1s2.52.14,2.77-.19c.12-.17-.07-.48-.58-.76a4.64,4.64,0,0,0-4.47.23C340.05,182.47,339.9,182.8,340,183Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.39,190.47c.15-.07,6.13-2.09,6.18,4.09s-6.15,5-6.16,4.78S368.39,190.47,368.39,190.47Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.27,197s.11.08.29.16a1.11,1.11,0,0,0,.81,0,2.67,2.67,0,0,0,1.21-2.4,3.62,3.62,0,0,0-.32-1.54,1.25,1.25,0,0,0-.82-.82.55.55,0,0,0-.63.3c-.08.18,0,.3-.07.31s-.14-.1-.09-.36a.76.76,0,0,1,.24-.39.84.84,0,0,1,.59-.16,1.52,1.52,0,0,1,1.14.95,3.64,3.64,0,0,1,.39,1.72,2.81,2.81,0,0,1-1.55,2.68,1.11,1.11,0,0,1-1-.16C370.28,197.13,370.25,197,370.27,197Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.74,172.06c-1-.55,2-3.79,4.46-4.9,3.71-1.69,9.38-2.73,12.8-1.76,4.12,1.17,7.55,3.22,9.62,7a24.39,24.39,0,0,1,2.74,12.4,7.46,7.46,0,0,1-.87,3.77c-.86,1.37-2.52,2.23-2.45,4.12a2.57,2.57,0,0,1-.64,1.88c-1.13,1.2-2.51.08-3.15-1.06-1.36-2.42-1.51-5.3-1.63-8.08a18,18,0,0,1,.39-5.87c.3-1,.79-2,1-3.05a3.72,3.72,0,0,0-.44-3.08,3.86,3.86,0,0,0-.5-.51,6.44,6.44,0,0,0-6.39-1.21c-3.48,1.23-9.42,3.07-11,1.89a9.5,9.5,0,0,1-2.77-2.8Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.72,197.57c.08,0,.13.35,0,.88a3.41,3.41,0,0,1-1.11,1.82,5.73,5.73,0,0,1-1.8,1c-.5.18-.82.23-.86.15s.22-.28.65-.56a12.2,12.2,0,0,0,1.58-1.12C352.31,198.83,352.52,197.53,352.72,197.57Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.79,
    y: 261.75,
    width: 39.74,
    height: 3.38,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.69,213.66h1a1.72,1.72,0,0,1,1.72,1.72V219a0,0,0,0,1,0,0H344a0,0,0,0,1,0,0v-3.65A1.72,1.72,0,0,1,345.69,213.66Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35,213.66h1.46a1.51,1.51,0,0,1,1.51,1.51V219a0,0,0,0,1,0,0h-4.48a0,0,0,0,1,0,0v-3.86A1.51,1.51,0,0,1,357.35,213.66Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,241.23c0,2.19-4.06,4-9.08,4s-9.08-1.78-9.08-4,4.07-4,9.08-4S362,239.05,362,241.23Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.04,
    y: 237.19,
    width: 11.28,
    height: 50.71,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.04 237.19 339.52 230.95 339.28 220.7 365.64 220.78 365.73 230.98 358.32 237.19 347.04 237.19",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.82,220.72H342.6a1.85,1.85,0,0,1,1.86-1.85H348a1.85,1.85,0,0,1,1.86,1.85Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.87,220.76h-7.36a1.89,1.89,0,0,1,1.89-1.89H360a1.89,1.89,0,0,1,1.89,1.89Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.53,225.07c0,.15-5.85.26-13,.26s-13.06-.11-13.06-.26,5.84-.26,13.06-.26S365.53,224.93,365.53,225.07Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,231c0,.14-5.85.26-13.07.26s-13.07-.12-13.07-.26,5.85-.26,13.07-.26S365.73,230.83,365.73,231Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.01,
    y: 269.57,
    width: 5.35,
    height: 12.42,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.36,
    y: 271.13,
    width: 3.68,
    height: 9.47,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.95,
    y: 272.79,
    width: 5.06,
    height: 6.5,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 269.66,
    width: 5.35,
    height: 12.42,
    transform: "translate(729.35 551.74) rotate(180)",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.32,
    y: 271.22,
    width: 3.68,
    height: 9.47,
    transform: "translate(720.32 551.91) rotate(180)",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.35,
    y: 272.88,
    width: 5.06,
    height: 6.5,
    transform: "translate(739.76 552.26) rotate(180)",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.54 298.39 332.95 298.39 332.95 291.29 347.04 287.9 358.32 287.9 373.54 291.29 373.54 298.39",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.95,
    y: 298.39,
    width: 40.59,
    height: 3.46,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.4,287.9l4.21-3.19,4.28.16,7.51,3,5.46-1s1.61,5.46,2.37,7.93c.9,2.92,1.76,5.89,1.76,5.89l-12.87,4.93-7.86.74s-5.36-1-5.66-1.87a2.33,2.33,0,0,1,.25-1.74,1.94,1.94,0,0,1-1-2c.24-1.3.73-1.91,1-2s2.25-.21,2.25-.21l-3.52-.83s-1.71-.51-1.38-1.93.81-1.42,1.34-1.59,2.7-.44,2.7-.44l-2.89-.17a1.39,1.39,0,0,1-1.28-2.18l.18-.19c1.08-1,5.32-2.45,5.32-2.45C373.12,289.05,372.31,288.78,372.4,287.9Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63,287.65c0,.15-2.32.55-5.07,1.5s-4.84,2.06-4.92,1.93a19.06,19.06,0,0,1,10-3.43Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.7,293.72c0,.14-.84.3-1.9.34s-1.91,0-1.92-.17.84-.3,1.9-.35S376.7,293.57,376.7,293.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,299.05a9.6,9.6,0,0,1-4.7.19,9,9,0,0,1-4.4-1.69c.07-.14,2,.79,4.48,1.17S379,298.89,379,299.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.63,298.61s-.15,0-.41.09a1.26,1.26,0,0,0-.91.46,2.13,2.13,0,0,0,0,1.56,7.08,7.08,0,0,0,.79,1.95l-.1-.09a10.72,10.72,0,0,0,1.19.53,11.57,11.57,0,0,0,4.66.79,16.76,16.76,0,0,1,2-.11,5.12,5.12,0,0,1-2,.48,10.42,10.42,0,0,1-4.87-.67,10.67,10.67,0,0,1-1.23-.56l-.07,0,0-.05a6.84,6.84,0,0,1-.79-2.14A2.29,2.29,0,0,1,371,299a1.37,1.37,0,0,1,1.17-.44C372.49,298.53,372.63,298.58,372.63,298.61Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.62,302.53c-.11-.1.36-.67.28-1.46s-.61-1.27-.53-1.39.24,0,.49.21a1.7,1.7,0,0,1,.56,1.14,1.74,1.74,0,0,1-.35,1.22C381.86,302.5,381.66,302.58,381.62,302.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.83,296.92c-.14,0,0-.89-.27-1.86s-.91-1.58-.82-1.7,1,.39,1.32,1.54S381,297,380.83,296.92Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.1,291.88c-.09-.1.24-.57.14-1.15s-.58-.9-.52-1,.2-.08.44.06a1.3,1.3,0,0,1,.59.88,1.31,1.31,0,0,1-.25,1C381.32,291.88,381.15,291.93,381.1,291.88Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character-1",
    "data-motion": "breathe",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.32,122.78l-.16,50.94,21.86,1,.63-12.39s7.76,1.55,9.76-5.66c1.28-4.61,1-40.19,1-40.19Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,120.1c-3.45,1-4.19,6.61-4.19,6.61l-5.4,11.93c-2.75-2.16-6.45-2-7.14,2.8-.51,3.49,3.83,4.2,3.83,4.2-2.53,4.3-4.24,7.78-7.92,11.87-4,4.43-6.22,4.88-10.54,5H95.13s-2.33-7.57-6.65-26.5c-4.79-21,20-18.3,24.65-23.66C120.63,103.57,142.1,117,131.25,120.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.93,137.94c-4-2.7-4.38-10.27-2-14.81a14.61,14.61,0,0,1,12.4-7.71,6,6,0,0,0,2-.22,5.59,5.59,0,0,0,2.17-2.07c3.6-4.68,7.14-9.27,13.84-9.27a7.61,7.61,0,0,1,4.22,1,6.65,6.65,0,0,1,2.53,3.35,14.27,14.27,0,0,1,3.92-1.41,4.85,4.85,0,0,1,3.94,1,3,3,0,0,1,.61,3.77,4.75,4.75,0,0,1,4.76,4c.36,2.24-2.85,3.81-3.18,4,0,0,1.76,3.68-2.44,5.89-1.68.89-3.88-.18-4.13-.31",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.89,142.84a10.32,10.32,0,0,1-1.67,7.41c-.15-.07.55-1.63,1-3.67S104.73,142.84,104.89,142.84Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53,140.34a9.23,9.23,0,0,1-.2,3.72,9.36,9.36,0,0,1-1.15,3.55,20.41,20.41,0,0,1,.6-3.65A20,20,0,0,1,107.53,140.34Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,131.93c.05.07-.56.53-1.35,1.45a14,14,0,0,0-2.36,4.06,34.35,34.35,0,0,0-1.3,4.58,8,8,0,0,1-.54,1.93,6.72,6.72,0,0,1,.15-2,22.5,22.5,0,0,1,1.18-4.71,11.83,11.83,0,0,1,2.58-4.13A4.25,4.25,0,0,1,115.1,131.93Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.16,126.21c.07,0,.29.49.43,1.38a9.25,9.25,0,0,1-.19,3.47,9,9,0,0,1-1.48,3.16c-.54.72-1,1.06-1,1a19.5,19.5,0,0,0,2-4.31A19,19,0,0,0,118.16,126.21Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.08,138.93c-.07.13-.74-.1-1.49-.52s-1.3-.87-1.23-1,.74.1,1.5.52S92.15,138.8,92.08,138.93Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.64,133.49a3.13,3.13,0,0,1-.63,2.22c-.67,1.12-1.58,1.7-1.67,1.58s.59-.84,1.2-1.87S102.48,133.46,102.64,133.49Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.88,131.75a4.27,4.27,0,0,1-1,2.65c-.87,1.33-2,2-2.06,1.92a23.84,23.84,0,0,1,1.6-2.23A22.85,22.85,0,0,1,105.88,131.75Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,110.42s-.41-.32-1.2-.76a8,8,0,0,0-3.66-1,9.82,9.82,0,0,0-5.37,1.44,13.35,13.35,0,0,0-4.58,5.1,23,23,0,0,0-1.85,4.78l-.09.32-.29-.16a11.08,11.08,0,0,0-4.88-1.25,11.81,11.81,0,0,0-4,.6,17.46,17.46,0,0,0-3.24,1.62,3.71,3.71,0,0,1,.73-.64,10.17,10.17,0,0,1,2.4-1.29,11.41,11.41,0,0,1,4.09-.74,11.2,11.2,0,0,1,5.12,1.23l-.39.17a22.42,22.42,0,0,1,1.89-4.9,13.39,13.39,0,0,1,4.8-5.27,10,10,0,0,1,5.65-1.4,7.75,7.75,0,0,1,3.75,1.15,5.63,5.63,0,0,1,.84.67C122,110.31,122,110.4,122,110.42Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.51,113.19s.61-.17,1.26.57a2.19,2.19,0,0,1,.5,1.59,2.5,2.5,0,0,1-1.27,1.82,3.62,3.62,0,0,1-2.66.36,7.61,7.61,0,0,1-2.73-1.33,28.69,28.69,0,0,0-2.68-1.83,11.17,11.17,0,0,0-3.23-1.14,13.73,13.73,0,0,0-6.59.45,18.15,18.15,0,0,0-4.87,2.48,50,50,0,0,0-3.89,3.29,6.09,6.09,0,0,1,.87-1.08,20.44,20.44,0,0,1,2.79-2.53A17.44,17.44,0,0,1,116,113.2a13.91,13.91,0,0,1,6.85-.51,11.58,11.58,0,0,1,3.39,1.2,26.19,26.19,0,0,1,2.71,1.9,7.32,7.32,0,0,0,2.55,1.29,3.21,3.21,0,0,0,2.35-.25,2.15,2.15,0,0,0,1.16-1.52,2,2,0,0,0-.36-1.42A1.88,1.88,0,0,0,133.51,113.19Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.89 449.05 87.59 479.74 71.02 479.37 72.26 448.62 88.89 449.05",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.46,478.4c-.14,0,.12-6.73.57-15s.94-15,1.08-15-.12,6.72-.58,15S79.59,478.4,79.46,478.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.68 477.62 71.11 477.19 71.02 479.37 87.59 479.74 87.68 477.62",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.42,469.54a2.37,2.37,0,0,1,.45-.65,11.88,11.88,0,0,1,1.55-1.51,11.14,11.14,0,0,1,2.76-1.67A8.83,8.83,0,0,1,86.4,468.1,7.33,7.33,0,0,1,87.53,470a2.12,2.12,0,0,1,.23.76,17.24,17.24,0,0,0-1.62-2.39,8.84,8.84,0,0,0-6.09-2.83,10.15,10.15,0,0,0-6.41,2.16C72.2,468.72,71.49,469.6,71.42,469.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.49 461.45 88.12 465.65 71.64 464.18 71.8 460.93 88.49 461.45"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,451.45l-.71,18.42s18.4,6.53,18.6,9.94l-35.68.3-.07-28.75Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,468.36a1.48,1.48,0,0,0-1,1.68,1.43,1.43,0,0,0,1.66,1,1.55,1.55,0,0,0,1.07-1.78,1.46,1.46,0,0,0-1.84-.88",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61,480.11v-2.29l34.63.41a2.71,2.71,0,0,1,1.23,1.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,470c0,.18-.89.25-1.75.82s-1.33,1.3-1.5,1.23.11-1.09,1.17-1.75S152.06,469.83,152,470Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.79,471.56c0,.17-.72.47-1.32,1.21s-.77,1.53-.95,1.52-.28-1,.48-1.91S155.79,471.4,155.79,471.56Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.93,476.09c-.16,0-.4-.84,0-1.8s1.28-1.35,1.35-1.2-.43.66-.8,1.46S158.1,476.07,157.93,476.09Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.71,465.74c-.07.16-.88-.08-1.87,0s-1.77.37-1.86.22.65-.78,1.82-.84S151.8,465.61,151.71,465.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,461.78a3.35,3.35,0,0,1-1.8,0,8.14,8.14,0,0,1-1.89-.58,8.59,8.59,0,0,1-1-.55,2.44,2.44,0,0,1-.55-.43.77.77,0,0,1-.07-.94,1,1,0,0,1,.77-.4,2.56,2.56,0,0,1,.67.1,6.25,6.25,0,0,1,1.13.39,6.54,6.54,0,0,1,1.66,1.09c.83.78,1.11,1.44,1.05,1.47s-.48-.49-1.33-1.13a6.89,6.89,0,0,0-1.61-.91,7.76,7.76,0,0,0-1-.33c-.38-.1-.71-.1-.81.07s0,.09,0,.2a1.74,1.74,0,0,0,.4.31,10.5,10.5,0,0,0,.95.55,9.78,9.78,0,0,0,1.75.67A10.71,10.71,0,0,1,152.36,461.78Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.52 462.4 134.58 466.49 151.83 466.4 151.81 462.7 134.52 462.4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,289.31l5.59,81.26s4.33,32.7,4.33,43-1.47,49.78-1.47,49.78H133.16L112.68,322.87s-2.06-1.76-2.35,0-12,52.06-13.09,60.12c-.89,6.42-8.41,78.68-8.41,78.68l-17.35-.74s-1.63-65.09-.45-86L74.12,303l4.21-20.39,56.73-2.12Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.77,317.79c0,.19,7.5,1.46,16.82,2.85s16.89,2.36,16.92,2.18-7.5-1.47-16.82-2.86S90.8,317.6,90.77,317.79Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,378.14c-.1.18,3.33,2.07,7.33,4.75s7.06,5.11,7.19,5-2.77-2.84-6.81-5.53S131.57,378,131.5,378.14Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1,377.53c0,.21,3.45-.58,7.64.05s7.25,2.29,7.35,2.09-2.91-2.17-7.26-2.77S75,377.38,75.1,377.53Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29,292.91c-.2.61-1.42,3.34-1.42,3.34l-4.5,11.19v15.43a2.13,2.13,0,0,0,3-1.68,49.64,49.64,0,0,0,.52-7.32L49.43,323s2.32-1.83.77-4l3.09,1.54a5,5,0,0,0,.77-3.73c-.51-1.92-5.91-7.32-5.91-7.32l9.12-.65s1.55-1.28,0-2.18-7.07-2.19-7.07-2.19a6.86,6.86,0,0,0,4.37-3.6,12,12,0,0,0,.9-6.29Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.39,181.68c-2.81-1.88-3.06.76-3.06.76l-16.13,6.83-6.79-3.08s-22.75-10.77-24.11-11.44a4,4,0,0,0-1.87-.28l-18.54-2.81h.47l-5-5.51-18.54-.24-6,.24L91,171.66H90l-21.08,11a26.09,26.09,0,0,0-3.51,1.83h0a5.93,5.93,0,0,0-.5.37c-2.61,2.24-21.68,62.44-22.05,63.56s-2.62,38.88-2.62,38.88l1.84,7.11a30.06,30.06,0,0,0,14.75.82l2.12-8,3-15.26L66.05,248l6.08-20.12.25-1.52c1.57,11,3.49,23.77,3.49,23.77l.07,6.35s-9.3,39.87-9.06,70c.2,24.64-.24,46.18-.24,46.18l90.8-1.21a3.8,3.8,0,0,1,3-4l3.34-.91L140.73,249.85l3.87-46.52.19,1.08s23.43,6.17,27.45,6.44S184,209.51,184,209.51l17.29-18.14S196.21,183.55,193.39,181.68Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,252.89c0,.14-9.64.8-21.54,1.47s-21.57,1.1-21.58.95,9.64-.8,21.55-1.47S127.89,252.74,127.9,252.89Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.28,238.37a18.56,18.56,0,0,1,.82,2.42,44.11,44.11,0,0,0,5.3,11,18.92,18.92,0,0,1,1.38,2.14A9.51,9.51,0,0,1,102.1,252a32,32,0,0,1-3.2-5.28,33.13,33.13,0,0,1-2.16-5.8A9.57,9.57,0,0,1,96.28,238.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.44,226.73c.15,0,.56,6.21.92,13.9s.53,13.91.39,13.92-.55-6.22-.91-13.9S103.3,226.73,103.44,226.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,234.07a12.72,12.72,0,0,1,0,2.86,54.22,54.22,0,0,1-2.9,13.45,12.69,12.69,0,0,1-1.12,2.62,20.85,20.85,0,0,1,.77-2.74c.51-1.68,1.16-4,1.72-6.63s.93-5,1.16-6.74A21.45,21.45,0,0,1,117.83,234.07Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.28,201.45a9.5,9.5,0,0,1-.89,4.84,9.4,9.4,0,0,1-2.82,4,44.41,44.41,0,0,0,2.34-4.24A46,46,0,0,0,186.28,201.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3,174.75c.06-.13,8.58,3.79,19,8.75s18.87,9.09,18.81,9.22-8.58-3.79-19-8.75S143.23,174.88,143.3,174.75Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.42,181.39a3.4,3.4,0,0,1,0,.7c0,.46,0,1.13-.06,2-.08,1.74-.21,4.25-.4,7.34-.38,6.2-1,14.76-1.64,24.21s-1.32,18-1.78,24.19c-.24,3-.43,5.54-.57,7.33-.06.83-.12,1.49-.16,2a3.23,3.23,0,0,1-.09.69,3.4,3.4,0,0,1,0-.7c0-.46,0-1.13.06-2,.08-1.73.21-4.24.4-7.34.38-6.2,1-14.76,1.64-24.21s1.32-17.95,1.78-24.19c.24-3,.43-5.54.57-7.33.06-.82.12-1.49.16-2A3.27,3.27,0,0,1,145.42,181.39Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.54,253.9a3.77,3.77,0,0,1-.14-.61c-.08-.46-.18-1-.31-1.78-.26-1.61-.62-3.83-1-6.54-.85-5.59-2-13.21-3.27-21.62s-2.31-16-3.12-21.65c-.37-2.72-.67-4.95-.89-6.57-.09-.73-.16-1.32-.21-1.78a2.31,2.31,0,0,1,0-.63,3,3,0,0,1,.14.61c.08.46.19,1,.31,1.78.26,1.61.62,3.83,1.05,6.54.85,5.59,2,13.21,3.27,21.63s2.32,16,3.12,21.64c.37,2.72.67,5,.89,6.56.09.74.16,1.33.21,1.79A2.31,2.31,0,0,1,76.54,253.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94,255.28A42.2,42.2,0,0,1,59,248.87a42.85,42.85,0,0,1-1.45-6.54,43.59,43.59,0,0,1,2,6.41A44.35,44.35,0,0,1,60.94,255.28Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87,172.16c0,.15-8.54.26-19.08.26s-19.09-.11-19.09-.26,8.55-.26,19.09-.26S126.87,172,126.87,172.16Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.21,289.33c-.15,0,.47-7.06,1.37-15.74s1.74-15.71,1.88-15.69-.47,7.06-1.37,15.74S102.35,289.35,102.21,289.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,319.07a2.27,2.27,0,0,1-.22-.55l-.53-1.61c-.46-1.4-1-3.45-1.72-6a146.43,146.43,0,0,1-4.58-40.84c.09-2.63.21-4.76.35-6.23.06-.69.11-1.25.16-1.69a2.33,2.33,0,0,1,.09-.59,3.46,3.46,0,0,1,0,.6c0,.44,0,1-.06,1.69-.08,1.47-.14,3.6-.18,6.23a166.37,166.37,0,0,0,1,20.52,169.09,169.09,0,0,0,3.58,20.22c.62,2.55,1.16,4.62,1.56,6,.18.67.32,1.21.43,1.64A2.17,2.17,0,0,1,116,319.07Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.14,
    y: 160.25,
    width: 1.37,
    height: 50.81,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.37,211.36a2.54,2.54,0,1,1-2.54-2.54A2.54,2.54,0,0,1,213.37,211.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.39,181.68l10.88-10.89,7.16.26,1.16,2.65s2.35,3,2.1,3.62a3.94,3.94,0,0,0-.28,1.21s1.44,2.42,1.14,3.18a8.75,8.75,0,0,0-.41,1.79l-1.23,1.69s-1.84.78-2.24,0,.42-1.79.42-1.79-4.2,2.79-5.19,3.5-3.3,3.48-4.68,2.33l-1.61,1.1Z",
    style: {
      fill: "#3B5A76"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabwork);
export default __webpack_public_path__ + "static/media/labwork.fa736635cf39e602621625b995ec8e2d.svg";
export { ForwardRef as ReactComponent };